import React, { Fragment } from 'react';
import classNames from 'classnames';
import Slide from './Slide';
import Layout from './Layout';
import Overlay from './Overlay';
import HorizontalScroll from './HorizontalScroll';
import HotspotImage from './HotspotImage';
import SlideHeading from './SlideHeading';
import AudioLink from './Audio';
import VideoLink from './Video';
import VideoFrame from './VideoFrame';
import Quote from './Quote';
import MobileSlide from './MobileSlide'
import Slide1Back from '../resources/backgrounds/Chapter 1 Slide 1-2.jpg';
import Slide2Back from '../resources/backgrounds/Chapter 1 Slide 2.jpg';
import Slide3Back from '../resources/backgrounds/Chapter 1 Slide 3-4.jpg';
import Slide4Back from '../resources/backgrounds/Chapter 1 Slide 4.jpg';
import Slide5Back from '../resources/backgrounds/Chapter 2 Slide 1-2.jpg';
import Slide6Back from '../resources/backgrounds/Chapter 2 Slide 2.jpg';
import Slide7Back from '../resources/backgrounds/Chapter 2 Slide 3.jpg';
import Slide8Back from '../resources/backgrounds/Chapter 2 Slide 4.jpg';
import Slide9Back from '../resources/backgrounds/Chapter 3 Slide 1-4.jpg';
import Slide9_Habib from '../resources/backgrounds/Chapter 3 Slide 3.jpg';
import Slide9_Habib2 from '../resources/backgrounds/Chapter 3 Slide 4.jpg';
import Slide9_SitIn from '../resources/backgrounds/Chapter 3 Slide 5.jpg';
import Slide10Back from '../resources/backgrounds/Chapter 3 Slide 2-6.jpg';
import Slide11Back from '../resources/backgrounds/Chapter 4 Slide 1.jpg';
import Slide12Back from '../resources/backgrounds/Chapter 4 Slide 2-3-4-5 – 3.jpg';
import Slide13Back from '../resources/backgrounds/Chapter 4 Slide 3-5.jpg';
import SlideLala from '../resources/backgrounds/Chapter 4 Slide 2-3-4-5 – 2.jpg';
import SlideLalaGalleryBack from '../resources/backgrounds/Chapter 2 Slide 4 – 1.jpg';
import ProjectCreditsBack from '../resources/backgrounds/Credits.jpg';
import AuratMarchBack from '../resources/backgrounds/AuratMarchBack.jpg';
import Fehmida from '../resources/media/ch1/Fahmida Cropped.jpg';
import Fehmida2 from '../resources/media/ch1/FahmidaRiaz2.jpeg';
import slideStyles from './css-modules/slide.module.css';
import layoutStyles from './css-modules/Layout.module.css';
import imageStyles from './css-modules/image_styles.module.css';
import dawnTitle from '../resources/media/ch1/ZiaML_DAWN.jpeg';
import hudoodFlogging from '../resources/media/ch1/Flogging_Dawn2.jpg';
import urduCartoon from '../resources/media/ch1/urdu cartoon 2_3.jpg';
import kishwarRekhta from '../resources/media/ch1/Kishwar_Naheed_Rekhta.jpg';
import hildaMedia from '../resources/media/ch2/hilda_still.jpg';
import zohra from '../resources/media/ch2/ZohraY.png';
import nationalConv from '../resources/media/ch2/1982_NationalConvention.jpg';
import nationalConv2 from '../resources/media/ch2/WAF_Convention.jpg';
import lalaArchives from '../resources/media/ch2/lalarukhArchives.jpg';
import farida from '../resources/media/ch3/FaridaShaheed_crop.png';
import samina from '../resources/media/ch3/Samina-Rehman_crop.png';
import jalib from '../resources/media/ch3/Jalib4.jpg';
import jalib_stamp from '../resources/media/ch3/HJ_stamp.png';
import jalib_assault from '../resources/media/ch3/JalibTussle.png';
import jalib2 from '../resources/media/ch3/AlisonVenning_JPP.jpg';
import sitin1 from '../resources/media/ch3/LalaRukh_JPP.jpg';
import sitin2 from '../resources/media/ch3/RahatAliDar_Beena2.jpg';

import afterMath1 from '../resources/media/ch3/press/WAF1_13Feb1983.jpg';
import afterMath2 from '../resources/media/ch3/press/WAF2_13Feb1983.jpg';
import afterMath3 from '../resources/media/ch3/press/WAF3_14Feb1983.jpg';
import afterMath4 from '../resources/media/ch3/press/WAF4_14Feb1983.jpg';
import afterMath5 from '../resources/media/ch3/press/WAF5_14Feb1983.jpg';

import lalaGallery1 from '../resources/media/ch4/Lala-Rukh-Masawi-Huqooq-1983–84-poster-for-Women’s-Action-Forum-offset-print-68.6-×-48.3-cm.jpg';
import lalaGallery2 from '../resources/media/ch4/Lala-Rukh-flyer-for-Women’s-Action-Forum-announcing-a-Jalsa-event-on-February-10-and-a-demonstration-on-February-12-1993-offset-print.jpg';
import lalaGallery3 from '../resources/media/ch4/LalaRukh_1985_documenta14.jpg';
import lalaGallery4 from '../resources/media/ch4/Rukh_Lala_OVERALL_02.jpg';
import lalaGallery5 from '../resources/media/ch4/Lala_documenta14.jpg';
import lalaGallery6 from '../resources/media/ch4/WAF_Poster1.jpg';

import crackGallery1 from '../resources/media/ch3/CrackDown/LathiCharge.jpg';
import crackGallery2 from '../resources/media/ch3/CrackDown/AzharJaffery_JPP.jpg';
import crackGallery3 from '../resources/media/ch3/CrackDown/AJ_JPP1.jpg';
import crackGallery4 from '../resources/media/ch3/CrackDown/AJ_JPP2.jpg';
import crackGallery5 from '../resources/media/ch3/CrackDown/AJ_JPP3.jpg';
import crackGallery6 from '../resources/media/ch3/CrackDown/AJ_JPP4.jpg';
import crackGallery7 from '../resources/media/ch3/CrackDown/AJ_JPP5.jpg';
import crackGallery8 from '../resources/media/ch3/CrackDown/AJ_JPP6.jpg';
import crackGallery9 from '../resources/media/ch3/CrackDown/AlisonVenning2_JPP.jpg';
import crackGallery10 from '../resources/media/ch3/CrackDown/Asma_Jahangir.jpg';
import crackGallery12 from '../resources/media/ch3/CrackDown/AzharJaffery2_JPP.jpg';
import crackGallery13 from '../resources/media/ch3/CrackDown/Dawn.jpg';
import crackGallery14 from '../resources/media/ch3/CrackDown/HJalib.jpg';
import crackGallery15 from '../resources/media/ch3/CrackDown/RahatAliDar_Beena3.jpg';
import crackGallery16 from '../resources/media/ch3/CrackDown/RahatAliDar_BeenaSarwar.jpg';
import crackGallery17 from '../resources/media/ch3/CrackDown/RahatAliDar4.jpg';

import hudoodGallery1 from '../resources/media/ch1/FloggingZia/Flogging_Dawn.jpg';
import hudoodGallery2 from '../resources/media/ch1/FloggingZia/Flogging_Wikimedia.jpg';

import post83Gallery1 from '../resources/media/ch4/Post83/1993_10yearson.jpg';
import post83Gallery2 from '../resources/media/ch4/Post83/WAF_Protest_General.jpg';
import post83Gallery4 from '../resources/media/ch4/Post83/lalaRukh_87.jpg';
import post83Gallery5 from '../resources/media/ch4/Post83/NawazSharif_s Shariat Bill.jpg';
import post83Gallery6 from '../resources/media/ch4/Post83/LahoreProtestWAF.jpg';

import WAF_logo from '../resources/waf_logo.png';
import ProjectTitle from '../slide-components/Project_Title';
import ProjectCredits from '../slide-components/Project_Credits';
import ProjectTitleBack from '../resources/backgrounds/Main Title.jpg';

import { MdChevronRight } from "react-icons/md";
import { MdChevronLeft } from "react-icons/md";

import TitleDawn from '../resources/media/ch1/Untitled-1.png';
import Zia from '../resources/media/ch1/ZiaSalute.png';
import ChapterTitle from './Chapter_Title';
import chapter_title_styles from './css-modules/chapter_title.module.css';
import Chapter1Title from '../resources/backgrounds/Chapter 1 Title.jpg';
import Chapter2Title from '../resources/backgrounds/Chapter 2 Title.jpg';
import Chapter3Title from '../resources/backgrounds/Chapter 3 Title.jpg';
import Chapter4Title from '../resources/backgrounds/Chapter 4 Title.jpg';
import WafBanner from '../resources/media/ch2/BannerEditTiled.png';
import LalaTrimm from '../resources/media/ch3/LalaCalanderTrimmedTit.png';
import Post83Title1 from '../resources/media/ch4/lalaRukh_87.jpg';
import Post83Title2 from '../resources/media/ch4/WAF_Protest_General2.jpg';

import auratMarch1 from '../resources/media/ch4/AM1.jpg';
import auratMarch2 from '../resources/media/ch4/AM2.jpg';
import auratMarch3 from '../resources/media/ch4/AM3.jpg';
import auratMarchVideo from '../resources/media/ch4/Video.jpg';

import chTStyles from './css-modules/chTitle.module.css';
import overlayStyles from './css-modules/overlay.module.css';

import main from '../resources/navbackgrounds/main.jpg';
import political from '../resources/navbackgrounds/political.jpg';
import twomurders from '../resources/navbackgrounds/twomurders.jpg';
import mallroad from '../resources/navbackgrounds/mallroad.jpg';
import literary from '../resources/navbackgrounds/literary.jpg';
import hindu from '../resources/navbackgrounds/hindu.jpg';

//Mobile Imports to follow ******************
import ProjectTitleMobile from './mobile-components/Project_Title_Mob';
import ChapterTitleMobile from './mobile-components/Chapter_Title_Mob';
import MobileSectionTitle from './mobile-components/MobileSectionTitle';
import mobileStyles from './css-modules/mobileStyles.module.css';
import Slide2Mobile from '../resources/backgrounds/Slide2MobileFix.jpg';
import NextChapterTitle from './mobile-components/NextChapterTitle';
import Chapter2Next from '../resources/backgrounds/chapter2Next.jpg';
import Chapter3Next from '../resources/backgrounds/chapter3Next.jpg';
import MobileQuote from './mobile-components/MobileQuote';
import ProjectCreditsMobile from './mobile-components/Project_Credits_Mob';

//Mobile Imports Before this comment ********

const imageArr = [Slide1Back,Slide2Back,Slide3Back, Slide4Back, Slide5Back,Slide6Back,Slide7Back,Slide9Back,Slide9_Habib,Slide9_Habib2,Slide9_SitIn,Slide10Back,Slide11Back,Slide12Back,Slide13Back,SlideLala,SlideLalaGalleryBack,Fehmida,Fehmida2,dawnTitle,hudoodFlogging,urduCartoon,kishwarRekhta,hildaMedia,zohra,nationalConv,nationalConv2,lalaArchives,farida,samina,jalib,jalib_stamp,jalib_assault,jalib2,sitin1,sitin2,lalaGallery1,lalaGallery2,lalaGallery3,lalaGallery4,lalaGallery5,lalaGallery6,crackGallery1,crackGallery2,crackGallery3,crackGallery4,crackGallery5,crackGallery6,crackGallery7,crackGallery8,crackGallery9,crackGallery10,crackGallery12,crackGallery13,crackGallery14,crackGallery15,crackGallery16,crackGallery17,hudoodGallery1,hudoodGallery2,post83Gallery1,post83Gallery2,post83Gallery4,post83Gallery5,post83Gallery6,TitleDawn,Zia,WAF_logo,ProjectTitleBack,Chapter1Title,Chapter2Title,Chapter3Title,Chapter4Title,WafBanner,LalaTrimm,Post83Title1,Post83Title2,auratMarch1,auratMarch2,auratMarch3,auratMarchVideo,main,political,twomurders,mallroad,literary,hindu];

const mobileImageArr = [ProjectCreditsBack,auratMarch3,auratMarch2,auratMarch1,lalaGallery6,lalaGallery5,lalaGallery4,lalaGallery3,lalaGallery2,lalaGallery1,post83Gallery6,post83Gallery5,post83Gallery4,post83Gallery2,post83Gallery1,auratMarchVideo,AuratMarchBack,lalaArchives,Slide12Back,SlideLala,Chapter3Next,Post83Title1,Post83Title2,WAF_logo,crackGallery17,crackGallery16,crackGallery15,crackGallery14,crackGallery13,crackGallery12,crackGallery10,crackGallery9,crackGallery8,crackGallery7,crackGallery6,crackGallery5,crackGallery4,crackGallery3,crackGallery2,crackGallery1,jalib2,jalib,sitin2,sitin1,samina,Slide9_SitIn,jalib_assault,jalib_stamp,farida,Chapter3Next,Chapter3Title,lalaArchives,nationalConv,Chapter3Next,Chapter2Next,zohra,hildaMedia,Slide6Back,Chapter2Title,Fehmida2,Fehmida,hudoodGallery2,hudoodGallery1,hudoodFlogging,urduCartoon,dawnTitle,Chapter2Next,kishwarRekhta,Slide2Mobile,Slide2Mobile,Slide1Back,Chapter1Title,main];

const slideMap = {
  "home" : {
    name : "Women Action Forum",
    slides : {
      "home" : {
        component : (
          <Slide bgImage={ProjectTitleBack}>
            {(props) => {
              return (
                <div className={slideStyles.slideflex} ref={props.addParallaxAndFadeRef(10)}>
                  <div className={slideStyles.slideContent}>
                    <ProjectTitle
                      title="Women’s Action Forum"
                      optionalLogo={WAF_logo}
                      description="Under the military rule of General Zia-ul-Haq (1977-1988), a movement was launched to resist the imposition of regressive laws against women. The Women's Action Forum (WAF) was a crucial part of the movement."
                    />
                  </div>
                </div>
              )}}
          </Slide>
        ),
        prev : "chapter1",
        next : "chapter1",
        menuInverted : false,
        hideChapterNumber: true,
        bottomBarMessage: '',
        hideVerticalNav: true,
      },
    }
  },
  "chapter1" : {
    name : "Chapter 1: Background",
    slides : {
      "chapter1" : {
        component : (
          <Slide bgImage={Chapter1Title}>
            {(props) => {
              return (
                <div ref={props.addFadeRef} className={slideStyles.slideflex}>
                  <div className={slideStyles.slideContent}>
                      <ChapterTitle
                        inverted
                        addParallaxAndFadeRef={props.addParallaxAndFadeRef}
                        chapter_number="1"
                        chapter_title="Background"
                        images={[
                          {image: TitleDawn, id: chTStyles.dawnTitle, shift : 15},
                          {image: Zia, id: chTStyles.ziaSalute, shift : -20}
                        ]}
                      />
                  </div>
                  <div className={chapter_title_styles.bottom_gradient} style={{background: 'linear-gradient(to bottom, rgba(30,87,153,0) 0%,rgba(53,68,75,0.48) 48%,rgba(53,68,75,0.97) 97%,rgba(53,68,75,1) 100%)'}}></div>
                </div>
              )}}
          </Slide>
        ),
        prev : "home",
        next : "chapter1slide1",
        menuInverted : true,
        hideChapterNumber: true,
        bottomBarMessage: ''
      },
      "chapter1slide1" : {
        slideName : "Zia declares Martial Law",
        component : (
          <Slide bgImage={Slide1Back}>
            {(props) => {
              return (
                <div className={slideStyles.slideflex}>
                  <div className={slideStyles.slideContent}>
                    <Layout layoutClassName="layout_flexed">
                      <div ref={props.addFadeRef} className={layoutStyles.layout_100}>
                        <SlideHeading inverted noPadding title="Zia declares Martial Law" year="(1977)" desc="After months of protests against Zulfiqar Ali Bhutto led by Pakistan National Alliance (PNA) - a coalition of right-wing political parties - the military under General Zia-ul-Haq seized the opportunity to intervene, ousted the prime minister and imposed martial law in the country."/>
                      </div>
                    </Layout>
                  </div>
                </div>
              )}}
          </Slide>
        ),
        prev : "chapter1",
        next : "chapter1slide2",
        menuInverted : true,
        bottomBarMessage: 'Click images to enlarge'
      },
      "chapter1slide2" : {
        slideName : "Political Activity is Banned",
        component : (
          <Slide bgImage={Slide2Back}>
            {(props) => {
              return (
              <Fragment>
                <div className={slideStyles.slideflex}>
                  <div ref={props.addFadeRef}>
                    <SlideHeading inverted title="Political Activity is Banned" desc="The protests preceding the imposition of martial law was used as a pretext to impose a ban on all sorts of political activities. Amidst acrimonious war of words between the PNA and Pakistan Peoples Party, the military projected itself as a stabilizing force that extinguished the ‘flames of politics’ threatening the country."/>
                  </div>
                  <div className={slideStyles.slideContent}>
                    <Layout layoutClassName="layout_flexed">
                      <div ref={props.addParallaxAndFadeRef(-15)} className={classNames(layoutStyles.layout_container, layoutStyles.container_45, layoutStyles.align_center, layoutStyles.justify_center)}>
                        <div id={imageStyles.dawn_zia_martial_law} className={classNames(imageStyles.rotate_0_dec_50_neg, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",0])}>
                          <img src={dawnTitle} alt="Title of DAWN Newspaper, July 6 1977" className={classNames(imageStyles.hover_effect)}/>
                        </div>
                      </div>
                      <div ref={props.addParallaxAndFadeRef(20)} className={classNames(layoutStyles.layout_container, layoutStyles.container_55, layoutStyles.align_center, layoutStyles.justify_center)}>
                        <div id={imageStyles.comic_zia_martial_law} className={classNames(imageStyles.rotate_0_dec_75, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",1])}>
                          <img src={urduCartoon} alt="A newspaper cartoon where the military is projected as a stabilizing force that extinguished the ‘flames of politics’ threatening the country." className={classNames(imageStyles.hover_effect)}/>
                        </div>
                      </div>
                    </Layout>
                  </div>
                  <Overlay
                    oId="1"
                    displayedOverlay={props.displayedOverlay}
                    closeOverlay={props.closeOverlay}
                    setDisplayedOverlay={props.setDisplayedOverlay}
                    slides={
                      [{
                        description : <p>Title of <i>DAWN</i>, July 6 1977</p>,
                        title : "Sample Title",
                        source : "DAWN",
                        render : ()=> <img alt="Title of DAWN Newspaper, July 6 1977" src={dawnTitle} style={window.innerHeight < 675 && {width: '90%', marginLeft: '5%'}}></img>,
                      },
                      {
                        description : "The protests preceding the imposition of martial law was used as a pretext to impose a ban on all sorts of political activities. Amidst acrimonious war of words between the PNA and Pakistan Peoples Party, the military projected itself as a stabilizing force that extinguished the ‘flames of politics’ threatening the country.",
                        title : "Sample Title2",
                        source : <i>Nawa-i-Waqt</i>,
                        render : ()=> <img alt="A newspaper cartoon where the military is projected as a stabilizing force that extinguished the ‘flames of politics’ threatening the country." src={urduCartoon}></img>,
                      }]
                    }
                  />
                </div>
              </Fragment>
              )}}
            </Slide>
        ),
        prev : "chapter1slide1",
        next : "chapter1slide3",
        menuInverted : true,
        bottomBarMessage: 'Click images to enlarge'
      },
      "chapter1slide3" : {
        slideName : "Hudood Ordinance (1979)",
        component : (
          <Slide bgImage={Slide4Back}>
            {(props) => {
              return (
                <div className={slideStyles.slideflex}>
                  <SlideHeading title="Hudood Ordinance " year="(1979)"/>
                  <div className={slideStyles.galleryChevrons_container}>
                    <p className={slideStyles.galleryTitle}>Gallery</p>
                    <div onClick={props.moveBackward} className={slideStyles.prevSlideChev}><MdChevronLeft/></div>
                    <div onClick={props.moveForward} className={slideStyles.nextSlideChev}><MdChevronRight/></div>
                  </div>
                  <div className={slideStyles.slideContent}>
                    <HorizontalScroll
                      scrollContainerRef={props.scrollContainerRef}
                      xPos={props.xPos}>
                      <Layout layoutClassName="layout_flexed" fixed_width>
                        <div ref={props.addParallaxAndFadeRef(5)} className={classNames(layoutStyles.layout_container, layoutStyles.container_60, layoutStyles.justify_center)}>
                          <p className={slideStyles.slidePara}>To provide legitimacy to his rule, Zia resorted to the slogan of Islam and transformation of Pakistan into a truly Islamic state. As part of these policies, Zia imposed the Hudud Ordinances in 1979. These added new criminal offences to the penal code of adultery and fornication, with punishments of public floggings, amputation and stoning to death.</p>
                          <p className={slideStyles.slidePara}>This law was considered intrinsically misogynistic since its application resulted in women being convicted for adultery/fornication if they reported a case of rape and were unable to produce ‘pious, male witnesses’.</p>
                        </div>
                        <div ref={props.addParallaxAndFadeRef(-6)} className={classNames(layoutStyles.layout_container, layoutStyles.container_40, layoutStyles.align_center, layoutStyles.justify_center)}>
                          <div id={imageStyles.hudoodOrdinanceMain} className={classNames(imageStyles.rotate_1_dec_25_neg, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["2",0])}>
                            <img alt="Public floggings were carried out ostensibly to ‘teach a lesson’ to criminals" src={hudoodFlogging} className={classNames(imageStyles.hover_effect)}/>
                          </div>
                        </div>
                      </Layout>
                      <div ref={props.addParallaxAndFadeRef(6)} className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_33)}>
                        <div id={imageStyles.hudoodGallery1} className={classNames(imageStyles.rotate_0_dec_25_neg, imageStyles.effected_image, imageStyles.laathi_gallery)} onClick={()=> props.setDisplayedOverlay(["2",1])}>
                          <img alt="Public floggings were carried out ostensibly to ‘teach a lesson’ to criminals"  src={hudoodGallery1} className={classNames(imageStyles.hover_effect)}/>
                        </div>
                      </div>
                      <div ref={props.addParallaxElsRef(-5)} className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_33, slideStyles.galleryItem_33_portrait)}>
                        <div id={imageStyles.hudoodGallery2} className={classNames(imageStyles.hudood_gallery_portrait, imageStyles.effected_image, imageStyles.laathi_gallery)} onClick={()=> props.setDisplayedOverlay(["2",2])}>
                          <img alt="Public floggings were carried out ostensibly to ‘teach a lesson’ to criminals"  src={hudoodGallery2} className={classNames(imageStyles.hover_effect)}/>
                        </div>
                      </div>
                    </HorizontalScroll>
                  </div>
                  <Overlay
                    oId="2"
                    displayedOverlay={props.displayedOverlay}
                    closeOverlay={props.closeOverlay}
                    setDisplayedOverlay={props.setDisplayedOverlay}
                    slides={
                      [{
                        description : "Public floggings were carried out ostensibly to ‘teach a lesson’ to criminals, but primarily to stifle any dissent or political opposition to Zia’s military regime.",
                        title : "Hudood Ordinance",
                        source : "DAWN",
                        render : ()=> <img alt="Public floggings were carried out ostensibly to ‘teach a lesson’ to criminals"  src={hudoodFlogging}></img>,
                      },
                      {
                        description : "Public floggings were carried out ostensibly to ‘teach a lesson’ to criminals, but primarily to stifle any dissent or political opposition to Zia’s military regime.",
                        title : "Hudood Ordinance",
                        source : "DAWN",
                        render : ()=> <img alt="Public floggings were carried out ostensibly to ‘teach a lesson’ to criminals"  src={hudoodGallery1}></img>,
                      },
                      {
                        description : "Public floggings were carried out ostensibly to ‘teach a lesson’ to criminals, but primarily to stifle any dissent or political opposition to Zia’s military regime.",
                        title : "Hudood Ordinance",
                        source : "DAWN",
                        render : ()=> <img alt="Public floggings were carried out ostensibly to ‘teach a lesson’ to criminals"  src={hudoodGallery2} style={window.innerHeight > 675 ? {width: '45%', marginLeft: '27.5%'} : {width: '36%', marginLeft: '32%'}}></img>,
                      }]
                    }
                  />
                </div>
              )}}
            </Slide>
        ),
        prev : "chapter1slide2",
        next : "chapter1slide4",
        menuInverted : false,
        bottomBarMessage: 'Click media to enlarge'
      },
      "chapter1slide4" : {
        slideName : "Resistance by women artists",
        component : (
          <Slide bgImage={Slide3Back}>
            {(props) => {
              return (
                <div className={slideStyles.slideflex}>
                  <div ref={props.addFadeRef}>
                    <SlideHeading title="Resistance by women artists" desc={<span>Amidst such brutalities, women artists, poets and activists took the lead in organizing resistance against the military junta. This resulted in the penning of some excellent resistance poetry, such as <i>Hum Gunahgar Auratain</i> by Kishwar Nahid and <i>Chadar aur Char Diwari</i> by Fahmida Riaz.</span>}/>
                  </div>
                  <div className={slideStyles.slideContent}>
                    <Layout wrapped layoutClassName="layout_flexed">
                      <div ref={props.addParallaxAndFadeRef(6)} className={classNames(layoutStyles.layout_container, layoutStyles.container_100)}>
                        <AudioLink link="https://rekhtacdn.azureedge.net/Images/SiteImages/Audio/BF417F1F-AD21-4A0C-962A-955050195960.mp3" audio_title="Chadar aur Char Diwari" narrated_by="Azra Naqvi" source="Rekhta"/>
                      </div>
                      <div style={{position: 'relative'}} className={classNames(layoutStyles.layout_container, layoutStyles.container_50, layoutStyles.justify_center)}>
                        <div ref={props.addParallaxAndFadeRef(-6)} id={imageStyles.fehmida_portait} className={classNames(imageStyles.rotate_1_dec_0, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["3",0])}>
                          <img src={Fehmida} alt="" className={classNames(imageStyles.hover_effect)}/>
                        </div>
                        <div ref={props.addParallaxAndFadeRef(5)} id={imageStyles.fehmida_landscape} className={classNames(imageStyles.rotate_0_dec_75_neg, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["3",1])}>
                          <img src={Fehmida2} alt="" className={classNames(imageStyles.hover_effect)}/>
                        </div>
                      </div>
                      <div ref={props.addParallaxAndFadeRef(-6)} className={classNames(layoutStyles.layout_container, layoutStyles.container_50, layoutStyles.justify_center)}>
                        <VideoLink setDisplayedOverlay={props.setDisplayedOverlay} overlayArray={["3",2]} image={kishwarRekhta} imageStyle={window.innerHeight > 675 ? {width: '80%', alignSelf: 'center', marginBottom: '5px', cursor: 'pointer'} : {width: '65%', alignSelf: 'center', marginBottom: '5px', cursor: 'pointer'}} linkMessage="Kishwar Nahid recites her poem" linkSource="Source: Rekhta"/>
                      </div>
                    </Layout>
                  </div>
                  <Overlay
                    oId="3"
                    displayedOverlay={props.displayedOverlay}
                    closeOverlay={props.closeOverlay}
                    setDisplayedOverlay={props.setDisplayedOverlay}
                    slides={
                      [{
                        description : <p>Kishwar Nahid</p>,
                        title : "Fehmida",
                        source : "alchetron.com",
                        render : ()=> <img alt="" style={{width: '62%', marginLeft: '24%'}} src={Fehmida}></img>,
                      },
                      {
                        description : <p>Fahmida Riaz</p>,
                        title : "Kishwar",
                        source : "DAWN",
                        render : ()=> <img alt="" src={Fehmida2}></img>,
                      },
                      {
                        description : <p>Kishwar Nahid recites <i>Hum Gunahgar Auratain</i></p>,
                        title : "Video 1",
                        source : "Rekhta",
                        render : ()=>  <VideoFrame link='https://www.youtube.com/embed/HOdcNBzCJuQ'/>,
                      }]
                    }
                  />
                </div>
              )}}
          </Slide>
        ),
        prev : "chapter1slide3",
        next : "chapter2",
        menuInverted : false,
        bottomBarMessage: 'Click media to enlarge'
      }
    }
  },
  "chapter2" : {
    name : "Chapter 2 : Formation of WAF",
    slides : {
      "chapter2" : {
        component : (
          <Slide bgImage={Chapter2Title}>
            {(props) => {
              return (
                <div ref={props.addFadeRef} className={slideStyles.slideflex}>
                  <div className={slideStyles.slideContent}>
                      <ChapterTitle
                        inverted
                        chapter_number="2"
                        chapter_title="Formation of WAF"
                        addParallaxAndFadeRef={props.addParallaxAndFadeRef}
                        images={[{image: WafBanner, id: chTStyles.wafBanner, shift : 20}]}
                      />
                  </div>
                  <div className={chapter_title_styles.bottom_gradient} style={{background: 'linear-gradient(to bottom, rgba(30,87,153,0) 0%,rgba(53,68,75,0.48) 48%,rgba(53,68,75,0.97) 97%,rgba(53,68,75,1) 100%)'}}></div>
                </div>
              )}}
          </Slide>
        ),
        prev : "chapter1slide4",
        next : "chapter2slide1",
        menuInverted : true,
        hideChapterNumber: true,
        bottomBarMessage: ''
      },
      "chapter2slide1" : {
        slideName : "The impetus for founding WAF - Fahmida Allah Bux Case - Slide 1",
        component : (
          <Slide bgImage={Slide5Back}>
            {(props) => {
              return (
                <div className={slideStyles.slideflex}>
                  <div ref={props.addFadeRef}>
                    <SlideHeading inverted title="The impetus for founding WAF" subtitle="Fahmida Allah Bux Case" year="(1981)"/>
                  </div>
                  <div className={slideStyles.slideContent}>
                    <Layout layoutClassName="layout_flexed">
                      <div ref={props.addParallaxAndFadeRef(8)} className={classNames(layoutStyles.layout_container, layoutStyles.container_52, layoutStyles.justify_center)}>
                        <p className={classNames(slideStyles.slidePara, slideStyles.white)}>The first conviction under the Hudud Ordinance was of a couple - Fahmida and Allah Bux - who had eloped to get married. Fahmida’s family filed a case of abduction against Allah Bux. The couple was caught and charged with <i>zina</i> (fornication) despite being married. Allah Bux was sentenced to death by stoning, and Fahmida, a minor, was awarded 100 stripes in public.</p>
                        <p className={classNames(slideStyles.slidePara, slideStyles.white)}>This event sparked an outrage amongst the members of Shirkat Gah, an organization of women activists who met in Lahore to discuss the kinds of action that could be taken. It was at this point that the Women's Action Forum came into being as a platform for women to raise voices against gender-based discrimnation.</p>
                      </div>
                      <div ref={props.addParallaxAndFadeRef(20)} className={classNames(layoutStyles.layout_container, layoutStyles.container_48, layoutStyles.justify_center)}>
                        <VideoLink setDisplayedOverlay={props.setDisplayedOverlay} overlayArray={["3",0]} inverted image={hildaMedia} imageStyle={{width: '70%', alignSelf: 'center', marginBottom: '20px', cursor: 'pointer'}} linkMessage="Hilda Saeed talks about the formation of WAF" linkSource="Source: Stories beyond borders, Bolo Bhi"/>
                      </div>
                    </Layout>
                  </div>
                  <Overlay
                    oId="3"
                    displayedOverlay={props.displayedOverlay}
                    closeOverlay={props.closeOverlay}
                    setDisplayedOverlay={props.setDisplayedOverlay}
                    slides={
                      [{
                        description : "Hilda Saeed talks about the formation of WAF",
                        title : "Video 1",
                        source : "Stories Beyond Borders, Bolo Bhi",
                        render : ()=>  <VideoFrame link='https://www.youtube.com/embed/OfqIYixpVWc'/>,
                      }]
                    }
                  />
                </div>
              )}}
          </Slide>
        ),
        prev : "chapter2",
        next : "chapter2slide2",
        menuInverted : true,
        bottomBarMessage: 'Click media to enlarge'
      },
      "chapter2slide2" : {
        slideName : "The impetus for founding WAF - Fahmida Allah Bux Case - Slide 2",
        component : (
          <Slide bgImage={Slide6Back} absoluteImage={{src: zohra, id: imageStyles.absoluteZohra}}>
            {(props) => {
              return (
                <div className={slideStyles.slideflex}>
                  <div ref={props.addFadeRef}>
                    <SlideHeading inverted title="The impetus for founding WAF" subtitle="Fahmida Allah Bux Case" year="(1981)" desc={<span>A meeting of <i>Shirkat Gah</i>, was called in Lahore about the Fehmida and Allah Bux case. <i>Shirkat Gah</i> was a women's NGO founded in 1975 with the goal of advocating and promoting women’s rights and empowerment.</span>}/>
                  </div>
                  <div className={slideStyles.slideContent}>
                    <Layout layoutClassName="layout_flexed">
                      <div ref={props.addFadeRef} className={layoutStyles.layout_100}>
                        <Quote addParallaxAndFadeRef={props.addParallaxAndFadeRef} inverted quote="It was on an afternoon in September 1981 that Aban Marker [of Shirkatgah] called. She told me about the distressed call she had just received from Najma Sadeque regarding the case of Fahmida-Allah Bux. I remember to this day the faces of the women around the table that evening when we met at Aban’s. Distressed yet determined." source="Zohra Yusuf, a founding WAF member"></Quote>
                      </div>
                    </Layout>
                  </div>
                </div>
              )}}
          </Slide>
        ),
        prev : "chapter2slide1",
        next : "chapter2slide3",
        menuInverted : true,
        bottomBarMessage: ''
      },
      "chapter2slide3" : {
        slideName : "First WAF Convention (1982)  - Slide 1",
        component : (
          <Slide bgImage={Slide7Back}>
            {(props) => {
              return (
                <div className={slideStyles.slideflex}>
                  <div ref={props.addFadeRef}>
                    <SlideHeading title="First WAF Convention" year="(1982)" desc="WAF holds its first convention in Lahore. The convention was instrumental in formalizing WAF as an organization."/>
                  </div>
                  <div className={slideStyles.slideContent}>
                    <Layout layoutClassName="layout_flexed">
                      <div ref={props.addParallaxAndFadeRef(-15)} className={classNames(layoutStyles.layout_container, layoutStyles.container_50, layoutStyles.align_center, layoutStyles.justify_center)}>
                        <div id={imageStyles.conventionOne} className={classNames(imageStyles.rotate_0_dec_50_neg, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",0])} >
                          <img alt="A large group of women and children pictured at the ‘First WAF Convention’ held in Lahore (1982)" src={nationalConv} className={classNames(imageStyles.hover_effect)}/>
                        </div>
                      </div>
                      <div ref={props.addParallaxAndFadeRef(20)} className={classNames(layoutStyles.layout_container, layoutStyles.container_50, layoutStyles.align_center, layoutStyles.justify_center)}>
                        <div id={imageStyles.conventionTwo} className={classNames(imageStyles.rotate_0_dec_75, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",1])} >
                          <img alt="Prominent members of WAF pictured at the ‘First WAF Convention’ held in Lahore (1982)" src={lalaArchives} className={classNames(imageStyles.hover_effect)}/>
                        </div>
                      </div>
                    </Layout>
                  </div>
                  <Overlay
                    oId="1"
                    displayedOverlay={props.displayedOverlay}
                    closeOverlay={props.closeOverlay}
                    setDisplayedOverlay={props.setDisplayedOverlay}
                    slides={
                      [{
                        description : "A large group of women and children pictured at the ‘First WAF Convention’ held in Lahore (1982)",
                        title : "Sample Title",
                        source : "The Second Floor's (T2F) Facebook page",
                        render : ()=> <img alt="First convention of WAF held in Lahore" src={nationalConv}></img>,
                      },
                      {
                        description : "Prominent members of WAF pictured at the ‘First WAF Convention’ held in Lahore (1982) ",
                        title : "Sample Title2",
                        source : "Women's Action Forum Lahore's Facebook page",
                        render : ()=> <img alt="First convention of WAF held in Lahore" src={lalaArchives}></img>,
                      }]
                    }
                  />
                </div>
              )}}
          </Slide>
        ),
        prev : "chapter2slide2",
        next : "chapter2slide4",
        menuInverted : false,
        bottomBarMessage: 'Click images to enlarge'
      },
      "chapter2slide4" : {
        slideName : "First WAF Convention (1982) - Slide 2",
        component : (
          <Slide bgImage={Slide8Back}>
            {(props) => {
              return (
                <div className={slideStyles.slideflex}>
                  <div className={slideStyles.slideContent}>
                    <Layout layoutClassName="layout_flexed">
                      <div ref={props.addFadeRef} className={classNames(layoutStyles.layout_container, layoutStyles.container_50, layoutStyles.align_center, layoutStyles.justify_center)}>
                        <SlideHeading inverted noPadding leftAlign title="First WAF Convention" year="(1982)" desc={<span>In the background of the photo (to the left) taken from the first WAF convention in Lahore, a poster can be seen with a repeating statement: Translation: ‘It is a crime against humanity that our women are confined to the four walls of their houses like prisoners’</span>}/>
                        <div ref={props.addParallaxAndFadeRef(-6)} id={imageStyles.convention_first_waf} className={classNames(imageStyles.rotate_0_dec_50_neg, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",0])} >
                          <img alt="First convention of WAF held in Lahore" src={nationalConv2} className={classNames(imageStyles.hover_effect)}/>
                        </div>
                      </div>
                      <div ref={props.addParallaxAndFadeRef(7)} className={classNames(layoutStyles.layout_container, layoutStyles.container_50, layoutStyles.align_center, layoutStyles.justify_center)}>
                        <div id={imageStyles.lalaPoster_first_waf} className={classNames(imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",1])}>
                          <img alt="Poster from the first waf convention in Lahore made by lala rukh" src={lalaGallery6} className={classNames(imageStyles.hover_effect)}/>
                        </div>
                      </div>
                    </Layout>
                  </div>
                  <Overlay
                    oId="1"
                    displayedOverlay={props.displayedOverlay}
                    closeOverlay={props.closeOverlay}
                    setDisplayedOverlay={props.setDisplayedOverlay}
                    slides={
                      [{
                        description : "A group of women and children pictured at the ‘First WAF Convention’ held in Lahore (1982)",
                        title : "Sample Title",
                        source : "The Second Floor's (T2F) Facebook page",
                        render : ()=> <img alt="First convention of WAF held in Lahore" src={nationalConv2}></img>,
                      },
                      {
                        description : <p><p>A publicity poster from the ‘First WAF Convention’ held in Lahore (1982).</p> <p>In the background a recurring statement can be seen: Translation:  ‘It is a crime against humanity that our women are confined to the four walls of their houses like prisoners’.</p><p> In the foreground, Fatima Jinnah is seen, alongside Muhammad Ali Jinnah, representing women leadership in the nation’s history. The poster was designed by Lala Rukh, a prominent WAF member and an artist from Lahore.</p></p>,
                        title : "Sample Title2",
                        source : <span>artasiapacific.com</span>,
                        render : ()=> <img style={window.innerHeight > 675 ? {width: '67%', marginLeft: '16.5%'} : {width: '58%', marginLeft: '21%'}} alt="Poster from the first waf convention in Lahore made by lala rukh" src={lalaGallery6}></img>,
                      }]
                    }
                  />
                </div>
              )}}
          </Slide>
        ),
        prev : "chapter2slide3",
        next : "chapter3",
        menuInverted : true,
        bottomBarMessage: 'Click images to enlarge'
      }
    }
  },
  "chapter3" : {
    name : "Chapter 3: Resistance against the law of evidence",
    slides : {
      "chapter3" : {
        component : (
          <Slide bgImage={Chapter3Title}>
            {(props) => {
              return (
                <div ref={props.addFadeRef} className={slideStyles.slideflex}>
                  <div className={slideStyles.slideContent}>
                    <ChapterTitle
                      inverted
                      chapter_number="3"
                      chapter_title="Resistance against the law of evidence"
                      addParallaxAndFadeRef={props.addParallaxAndFadeRef}
                      images={[{image: LalaTrimm, id: chTStyles.lalaTrim, shift : 15}]}
                    />
                  </div>
                  <div className={chapter_title_styles.bottom_gradient} style={{background: 'linear-gradient(to bottom, rgba(30,87,153,0) 0%,rgba(53,68,75,0.48) 48%,rgba(53,68,75,0.97) 97%,rgba(53,68,75,1) 100%)'}}></div>
                </div>
              )}}
          </Slide>
        ),
        prev : "chapter2slide4",
        next : "chapter3slide1",
        menuInverted : true,
        hideChapterNumber: true,
        bottomBarMessage: ''
      },
      "chapter3slide1" : {
        slideName : "Sit in against the law of evidence - Slide 1",
        component : (
          <Slide bgImage={Slide9Back}>
             {(props) => {
               return (
                 <div className={slideStyles.slideflex}>
                   <SlideHeading
                     title="Sit in against the law of evidence"
                     desc={<p><i>Qanun-i-Shahadat</i> or the law of evidence was another regressive law introduced by the Zia regime in the name of Islamization. According to the law, the testimony of two women was equivalent to that of one man. On 12 February 1983, WAF, along with the Pakistan Women Lawyers, gave a call to march to the High Court with a petition against the then proposed Law of Evidence. The sit-in begins on the Hall Road.</p>}
                   />
                   <div className={slideStyles.slideContent}>
                     <Layout layoutClassName="layout_flexed">
                       <div className={classNames(layoutStyles.layout_container, layoutStyles.container_50, layoutStyles.align_center, layoutStyles.justify_center)}>
                        <div ref={props.addParallaxAndFadeRef(-7)} id={imageStyles.sitin_1} className={classNames(imageStyles.rotate_0_dec_50_neg, slideStyles.imgBorder, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",0])} >
                          <img src={sitin1} alt="Sit in at the Hall road against the law of evidence" className={classNames(imageStyles.hover_effect)}/>
                        </div>
                       </div>
                       <div className={classNames(layoutStyles.layout_container, layoutStyles.container_50, layoutStyles.align_center, layoutStyles.justify_center)}>
                        <div ref={props.addParallaxAndFadeRef(8)} id={imageStyles.sitin_2} className={classNames(imageStyles.rotate_0_dec_75, slideStyles.imgBorder, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",1])} >
                         <img src={sitin2} alt="A group of women protesters at the Hall road on 12 February 1983. Banners mention ‘Pakistan Women Lawyers Association’, who had joined efforts with WAF for the protest." className={classNames(imageStyles.hover_effect)}/>
                        </div>
                      </div>
                     </Layout>
                    </div>
                    <Overlay
                      oId="1"
                      displayedOverlay={props.displayedOverlay}
                      closeOverlay={props.closeOverlay}
                      setDisplayedOverlay={props.setDisplayedOverlay}
                      slides={
                        [{
                          description : "Sit in at the Hall road against the law of evidence",
                          title : "Sample Title",
                          source : "Photograph by LalaRukh",
                          render : ()=> <img alt="Sit in at the Hall road against the law of evidence" src={sitin1}></img>,
                        },
                        {
                          description : `A group of women protesters at the Hall road on 12 February 1983. Banners mention ‘Pakistan Women Lawyers Association’, who had joined efforts with WAF for the protest.`,
                          title : "Sample Title2",
                          source : "Photograph by Rahat Ali Dar",
                          render : ()=> <img alt="Sit in at the Hall road against the law of evidence" src={sitin2}></img>,
                        }]
                      }
                    />
                 </div>
               )
             }}
          </Slide>
        ),
        prev : "chapter3",
        next : "chapter3slide2",
        menuInverted : false,
        bottomBarMessage: 'Click images to enlarge'
      },
      "chapter3slide2" : {
        slideName : "Sit in against the law of evidence - Slide 2",
        component : (
          <Slide bgImage={Slide10Back} absoluteImage={{src: farida, id: imageStyles.absoluteFarida}}>
            {(props) => {
              return (
                <div className={slideStyles.slideflex}>
                  <SlideHeading inverted
                    title="Sit in against the law of evidence"
                    desc="Walking in groups of four, the protesting women had defied Section 144 which banned public assemblies. Some women had even kept this hidden from male family members."
                  />
                  <div className={slideStyles.slideContent}>
                    <Layout layoutClassName="layout_flexed">
                      <div className={layoutStyles.layout_100}>
                        <Quote addParallaxAndFadeRef={props.addParallaxAndFadeRef} inverted quote="Section 144 had been imposed so Hina Jilani had an idea that we should reach the high court in small groups of twos and threes and protest there,” she recalls. “But when we reached Hall Road, we could see that there was already a lot of police who had cordoned off the road so we couldn’t go ahead." source="Farida Shaheed, a founding WAF member"></Quote>
                      </div>
                    </Layout>
                  </div>
                </div>
              )}}
          </Slide>
        ),
        prev : "chapter3slide1",
        next : "chapter3slide3",
        menuInverted : true,
        bottomBarMessage: ''
      },
      "chapter3slide3" : {
        slideName : "Habib Jalib - in solidarity with WAF’s struggle - Slide 1",
        component : (
          <Slide bgImage={Slide9_Habib}>
            {(props) => {
              return (
              <Fragment>
                <div className={slideStyles.slideflex}>
                  <SlideHeading title="Habib Jalib - in solidarity with WAF’s struggle" desc="The famous revolutionary poet also joined and addressed the women’s sit in. These photographs, which in later years would become popular images of Jalib, were taken at the sit in."/>
                  <div className={slideStyles.slideContent}>
                    <Layout layoutClassName="layout_flexed">
                      <div className={classNames(layoutStyles.layout_container, layoutStyles.container_45, layoutStyles.align_center, layoutStyles.justify_center)}>
                        <div ref={props.addParallaxAndFadeRef(-15)} id={imageStyles.jalib_1} className={classNames(imageStyles.rotate_0_dec_50_neg, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",0])} >
                          <img src={jalib} alt="Habib Jalib amidst women protesters on 12 February 1983" className={classNames(imageStyles.hover_effect)}/>
                        </div>
                      </div>
                      <div className={classNames(layoutStyles.layout_container, layoutStyles.container_55, layoutStyles.align_center, layoutStyles.justify_center)}>
                        <div ref={props.addParallaxAndFadeRef(20)} id={imageStyles.jalib_2} className={classNames(imageStyles.rotate_0_dec_75, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",1])} >
                          <img src={jalib2} alt="Habib Jalib’s passionate address to women protestors at the Hall road" className={classNames(imageStyles.hover_effect)}/>
                        </div>
                      </div>
                    </Layout>
                  </div>
                  <Overlay
                    oId="1"
                    displayedOverlay={props.displayedOverlay}
                    closeOverlay={props.closeOverlay}
                    setDisplayedOverlay={props.setDisplayedOverlay}
                    slides={
                      [{
                        description : "Habib Jalib amidst women protesters on 12 February 1983",
                        title : "Sample Title",
                        source : "",
                        render : ()=> <img alt="Habib Jalib amidst women protesters on 12 February 1983" src={jalib}></img>,
                      },
                      {
                        description : "Habib Jalib’s passionate address to women protestors at the Hall road",
                        title : "Sample Title2",
                        source : "Photograph by Alison Venning",
                        render : ()=> <img alt="Habib Jalib’s passionate address to women protestors at the Hall road" src={jalib2}></img>,
                      }]
                    }
                  />
                </div>
              </Fragment>
              )}}
          </Slide>
        ),
        prev : "chapter3slide2",
        next : "chapter3slide4",
        menuInverted : false,
        bottomBarMessage: 'Click images to enlarge'
      },
      "chapter3slide4" : {
        slideName : "Habib Jalib - in solidarity with WAF’s struggle - Slide 2",
        component : (
          <Slide bgImage={Slide9_Habib2}  absoluteImage={{src: jalib_assault, id: imageStyles.jalibAssault}}>
            {(props) => {
              return (
              <Fragment>
                <div className={slideStyles.slideflex}>
                  <SlideHeading title="Habib Jalib - in solidarity with WAF’s struggle"
                  desc="Jalib recited the following poem at the sit-in. The poem later became to be known as the WAF anthem"/>
                  <div className={slideStyles.slideContent}>
                    <Layout layoutClassName="layout_flexed">
                      <div ref={props.addParallaxAndFadeRef(-30)} className={classNames(layoutStyles.layout_container, layoutStyles.container_45, layoutStyles.align_center, layoutStyles.justify_center)}>
                        <img src={jalib_stamp} alt="A Pakistan post stamp showing Habib Jalib" onClick={()=> props.setDisplayedOverlay(["1",0])} className={classNames(imageStyles.rotate_0_dec_50_neg)} id={imageStyles.jalib_stamp}/>
                      </div>
                      <div ref={props.addParallaxAndFadeRef(10)} className={classNames(layoutStyles.layout_container, layoutStyles.container_55, layoutStyles.align_center, layoutStyles.justify_center)}>
                        <div className="urdu shair">
                          <p>اب دہر میں بے یار و مددگار نہیں ہم</p>
                          <p>پہلے کی طرح بےکس و لاچار نہیں ہم</p>
                          <div className="margined">
                            <p>آتا ہے ہمیں اپنے مقدر کو بنانا</p>
                            <p>تقدیر پہ شاکر پس دیوار نہیں ہم</p>
                          </div>
                          <div className="margined">
                            <p className="shair_source">حبیب جالب</p>
                          </div>
                        </div>
                      </div>
                    </Layout>
                  </div>
                </div>
              </Fragment>
              )}}
          </Slide>
        ),
        prev : "chapter3slide3",
        next : "chapter3slide5",
        menuInverted : false,
        bottomBarMessage: ''
      },
      "chapter3slide5" : {
        slideName : "Laathi Charge and Tear gas shelling - Slide 1",
        component : (
          <Slide bgImage={Slide9_SitIn}>
             {(props) => {
               return (
                 <div className={slideStyles.slideflex}>
                   <SlideHeading inverted
                     title="Laathi Charge and Tear gas shelling"
                     desc="The police proceeds to lathi-charge and fires tear-gas shells at the protesters on the Hall Road, Regal chowk and Mall Road. The photographs taken by journalists, Azhar Jaffery and Rahat Ali Dar, reveal the violence that ensued on the streets of Lahore."
                   />
                   <div className={slideStyles.galleryChevrons_container}>
                     <p className={classNames(slideStyles.galleryTitle, slideStyles.white)}>Gallery</p>
                     <div onClick={props.moveBackward} className={classNames(slideStyles.prevSlideChev, slideStyles.invertedChev)}><MdChevronLeft/></div>
                     <div onClick={props.moveForward} className={classNames(slideStyles.nextSlideChev, slideStyles.invertedChev)}><MdChevronRight/></div>
                   </div>
                   <div className={slideStyles.slideContent}>
                     <HorizontalScroll
                       scrollContainerRef={props.scrollContainerRef}
                       xPos={props.xPos}>
                       <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_33)}>
                         <div ref={props.addParallaxAndFadeRef(5)} className={classNames(imageStyles.laathi_gallery, imageStyles.laathi_gallery_margined, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",0])}>
                            <img alt="Crackdown against the law of evidence" src={crackGallery1} className={classNames(imageStyles.hover_effect)}/>
                         </div>
                       </div>
                       <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_33)}>
                         <div ref={props.addParallaxAndFadeRef(-4)} className={classNames(imageStyles.laathi_gallery, imageStyles.laathi_gallery_margined, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",1])}>
                            <img alt="Crackdown against the law of evidence" src={crackGallery2} className={classNames(imageStyles.hover_effect)} />
                         </div>
                       </div>
                       <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_33)}>
                         <div ref={props.addParallaxAndFadeRef(4)} className={classNames(imageStyles.laathi_gallery, imageStyles.laathi_gallery_margined, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",2])}>
                           <img alt="Crackdown against the law of evidence" src={crackGallery3} className={classNames(imageStyles.hover_effect)}/>
                         </div>
                       </div>
                       <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_33)}>
                         <div ref={props.addParallaxAndFadeRef(-4)} className={classNames(imageStyles.laathi_gallery, imageStyles.laathi_gallery_margined, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",3])}>
                           <img alt="Crackdown against the law of evidence" src={crackGallery4} className={classNames(imageStyles.hover_effect)}/>
                         </div>
                       </div>
                       <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_33)}>
                         <div ref={props.addParallaxAndFadeRef(5)} className={classNames(imageStyles.laathi_gallery, imageStyles.laathi_gallery_margined, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",4])}>
                           <img alt="Crackdown against the law of evidence" src={crackGallery5} className={classNames(imageStyles.hover_effect)}/>
                         </div>
                       </div>
                       <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_33, slideStyles.galleryItem_33_portrait)}>
                         <div ref={props.addParallaxAndFadeRef(-4)} className={classNames(imageStyles.laathi_gallery, imageStyles.laathi_gallery_margined, imageStyles.laathi_gallery_portrait, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",5])}>
                           <img alt="Crackdown against the law of evidence" src={crackGallery6} className={classNames(imageStyles.hover_effect)}/>
                         </div>
                       </div>
                       <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_33, slideStyles.galleryItem_33_portrait)}>
                         <div ref={props.addParallaxAndFadeRef(5)} className={classNames(imageStyles.laathi_gallery, imageStyles.laathi_gallery_margined, imageStyles.laathi_gallery_portrait, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",6])}>
                           <img alt="Crackdown against the law of evidence" src={crackGallery7} className={classNames(imageStyles.hover_effect)}/>
                         </div>
                       </div>
                       <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_33, slideStyles.galleryItem_33_portrait)}>
                         <div ref={props.addParallaxAndFadeRef(-4)} className={classNames(imageStyles.laathi_gallery, imageStyles.laathi_gallery_margined, imageStyles.laathi_gallery_portrait, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",7])}>
                           <img alt="Crackdown against the law of evidence" src={crackGallery8} className={classNames(imageStyles.hover_effect)}/>
                         </div>
                       </div>
                       <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_33)}>
                         <div ref={props.addParallaxAndFadeRef(5)} className={classNames(imageStyles.laathi_gallery, imageStyles.laathi_gallery_margined, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",8])}>
                           <img alt="Crackdown against the law of evidence" src={crackGallery9} className={classNames(imageStyles.hover_effect)}/>
                         </div>
                       </div>
                       <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_33)}>
                         <div ref={props.addParallaxAndFadeRef(-5)} className={classNames(imageStyles.laathi_gallery, imageStyles.laathi_gallery_margined, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",9])}>
                           <img alt="Crackdown against the law of evidence" src={crackGallery10} className={classNames(imageStyles.hover_effect)}/>
                         </div>
                       </div>
                       <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_33)}>
                         <div ref={props.addParallaxAndFadeRef(4)} className={classNames(imageStyles.laathi_gallery, imageStyles.laathi_gallery_margined, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",11])}>
                           <img alt="Crackdown against the law of evidence" src={crackGallery12} className={classNames(imageStyles.hover_effect)}/>
                         </div>
                       </div>
                       <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_33)}>
                         <div ref={props.addParallaxAndFadeRef(-4)} className={classNames(imageStyles.laathi_gallery, imageStyles.laathi_gallery_margined, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",12])}>
                           <img alt="Crackdown against the law of evidence" src={crackGallery13} className={classNames(imageStyles.hover_effect)}/>
                         </div>
                       </div>
                       <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_33)}>
                         <div ref={props.addParallaxAndFadeRef(5)} className={classNames(imageStyles.laathi_gallery, imageStyles.laathi_gallery_margined, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",13])}>
                           <img alt="Crackdown against the law of evidence" src={crackGallery14} className={classNames(imageStyles.hover_effect)}/>
                         </div>
                       </div>
                       <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_33)}>
                         <div ref={props.addParallaxAndFadeRef(-5)} className={classNames(imageStyles.laathi_gallery, imageStyles.laathi_gallery_margined, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",14])}>
                           <img alt="Crackdown against the law of evidence" src={crackGallery15} className={classNames(imageStyles.hover_effect)}/>
                         </div>
                       </div>
                       <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_33)}>
                         <div ref={props.addParallaxAndFadeRef(-4)} className={classNames(imageStyles.laathi_gallery, imageStyles.laathi_gallery_margined, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",15])}>
                           <img alt="Crackdown against the law of evidence" src={crackGallery16} className={classNames(imageStyles.hover_effect)}/>
                         </div>
                       </div>
                       <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_33)}>
                         <div ref={props.addParallaxAndFadeRef(5)} className={classNames(imageStyles.laathi_gallery, imageStyles.laathi_gallery_margined, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",16])}>
                           <img alt="Crackdown against the law of evidence" src={crackGallery17} className={classNames(imageStyles.hover_effect)}/>
                         </div>
                       </div>
                     </HorizontalScroll>
                    </div>
                    <Overlay
                      oId="1"
                      displayedOverlay={props.displayedOverlay}
                      closeOverlay={props.closeOverlay}
                      setDisplayedOverlay={props.setDisplayedOverlay}
                      slides={
                        [{
                          description : "Lathi charge and tear gas shelling at Regal chowk",
                          title : "Sample Title",
                          source : "The Second Floor's (T2F) Facebook page",
                          render : ()=> <img alt="Crackdown against the law of evidence" src={crackGallery1}></img>,
                        },
                        {
                          description : "Lathi charge by policemen and policewomen to disperse the protests",
                          title : "Sample Title2",
                          source : "Photograph by Azhar Jaffery",
                          render : ()=> <img alt="Crackdown against the law of evidence" src={crackGallery2}></img>,
                        },
                        {
                          description : "A protestor faces a policewoman during the lathi charge",
                          title : "Sample Title2",
                          source : "Photograph by Azhar Jaffery",
                          render : ()=> <img alt="Crackdown against the law of evidence" src={crackGallery3}></img>,
                        },
                        {
                          description : "A collapsed protester holds on to a policeman’s baton",
                          title : "Sample Title2",
                          source : "Photograph by Azhar Jaffery",
                          render : ()=> <img alt="Crackdown against the law of evidence" src={crackGallery4}></img>,
                        },
                        {
                          description : "A protester clashes with a policewoman",
                          title : "Sample Title2",
                          source : "Photograph by Azhar Jaffery",
                          render : ()=> <img alt="Crackdown against the law of evidence" src={crackGallery5}></img>,
                        },
                        {
                          description : "A protester ducks to escape batons of the police",
                          title : "Sample Title2",
                          source : "Photograph by Azhar Jaffery",
                          render : ()=> <img alt="Crackdown against the law of evidence" style={window.innerHeight > 675 ? {width: '78%', marginLeft: '11%'} : {width: '70%', marginLeft: '15%'}} src={crackGallery6}></img>,
                        },
                        {
                          description : "A woman attends to an injured protester",
                          title : "Sample Title2",
                          source : "Photograph by Azhar Jaffery",
                          render : ()=> <img alt="Crackdown against the law of evidence" style={window.innerHeight > 675 ? {width: '62%', marginLeft: '19%'} : {width: '55%', marginLeft: '22.5%'}} src={crackGallery7}></img>,
                        },
                        {
                          description : "Mass arrests also took place following the lathi charge, however, reports convey the prisoners were let go after a few hours.",
                          title : "Sample Title2",
                          source : "Photograph by Azhar Jaffery",
                          render : ()=> <img alt="Crackdown against the law of evidence" style={window.innerHeight > 675 ? {width: '62%', marginLeft: '19%'} : {width: '55%', marginLeft: '22.5%'}} src={crackGallery8}></img>,
                        },
                        {
                          description : "A group of women supporting an injured protester",
                          title : "",
                          source : "Photograph by Alison Venning",
                          render : ()=> <img alt="Crackdown against the law of evidence" src={crackGallery9}></img>,
                        },
                        {
                          description : "A famous image of Asma Jahangir, a member of the Pakistan Women Lawyers’ Association, facing the attacks of the police.",
                          title : "Sample Title2",
                          source : "",
                          render : ()=> <img alt="Crackdown against the law of evidence" src={crackGallery10}></img>,
                        },
                        {
                          description : "Aitzaz Ahsan, the famous lawyer is pictured trying to quell the blows of police on the protesters",
                          title : "Sample Title2",
                          source : "Photograph by Azhar Jaffery",
                          render : ()=> <img alt="Crackdown against the law of evidence" src={crackGallery12}></img>,
                        },
                        {
                          description : "A protester surrounded by policewomen.",
                          title : "Sample Title2",
                          source : "Photograph by Azhar Jaffery",
                          render : ()=> <img alt="Crackdown against the law of evidence" src={crackGallery13}></img>,
                        },
                        {
                          description : "Habib Jalib, the famous poet amidst attacking batons",
                          title : "Sample Title2",
                          source : "DAWN",
                          render : ()=> <img alt="Crackdown against the law of evidence" src={crackGallery14}></img>,
                        },
                        {
                          description : "A group of women protesters clash with policemen",
                          title : "Sample Title2",
                          source : "Photograph by Rahat Ali Dar",
                          render : ()=> <img alt="Crackdown against the law of evidence" src={crackGallery15}></img>,
                        },
                        {
                          description : "A group of women protesters clash with policemen",
                          title : "Sample Title2",
                          source : "Photograph by Rahat Ali Dar",
                          render : ()=> <img alt="Crackdown against the law of evidence" src={crackGallery16}></img>,
                        },
                        {
                          description : "A group of women protesters clash with policemen",
                          title : "Sample Title2",
                          source : "Photograph by Rahat Ali Dar",
                          render : ()=> <img alt="Crackdown against the law of evidence" src={crackGallery17}></img>,
                        }]
                      }
                    />
                 </div>
               )
             }}
          </Slide>
        ),
        prev : "chapter3slide4",
        next : "chapter3slide6",
        menuInverted : true,
        bottomBarMessage: 'Click images to enlarge'
      },
      "chapter3slide6" : {
        slideName : "Laathi Charge and Tear gas shelling - Slide 2",
        component : (
          <Slide bgImage={Slide10Back} absoluteImage={{src: samina, id: imageStyles.absoluteSamina}}>
            {(props) => {
              return (
                <div ref={props.addFadeRef} className={slideStyles.slideflex}>
                  <SlideHeading inverted
                    title="Laathi Charge and Tear gas shelling"
                    desc="Samina Rahman, a founding WAF member from Lahore, recalls how women felt hopeful and liberated during the protest at Hall road/ Regal chowk"
                  />
                  <div className={slideStyles.slideContent}>
                    <Layout layoutClassName="layout_flexed">
                      <div className={layoutStyles.layout_100}>
                        <Quote addParallaxAndFadeRef={props.addParallaxAndFadeRef} inverted quote="It was unusual. We were breaking silence and challenging the martial law. A lot of it was based on impulse; just the desire to break barriers. It was a very liberating time. When you’re on the street, resisting force and you feel you’re breaking through, there is a moment of hope." source="Samina Rehman"></Quote>
                      </div>
                    </Layout>
                  </div>
                </div>
              )}}
          </Slide>
        ),
        prev : "chapter3slide5",
        next : "chapter3slide7",
        menuInverted : true,
        bottomBarMessage: ''
      },
      "chapter3slide7" : {
        slideName : "Aftermath",
        component : (
          <Slide bgImage={Slide9Back}>
             {(props) => {
               return (
                 <div className={slideStyles.slideflex}>
                   <SlideHeading
                     title="Aftermath"
                     subtitle="Newspaper Coverage"
                     desc=""
                   />
                   <div className={slideStyles.galleryChevrons_container}>
                     <p className={classNames(slideStyles.galleryTitle)}>Gallery</p>
                     <div onClick={props.moveBackward} className={classNames(slideStyles.prevSlideChev)}><MdChevronLeft/></div>
                     <div onClick={props.moveForward} className={classNames(slideStyles.nextSlideChev)}><MdChevronRight/></div>
                   </div>
                   <div className={slideStyles.slideContent}>
                     <HorizontalScroll
                       scrollContainerRef={props.scrollContainerRef}
                       xPos={props.xPos}>
                       <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_25_portrait)}>
                         <div id={imageStyles.afterMath1} ref={props.addParallaxAndFadeRef(5)} className={classNames(imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",0])}>
                            <img alt="Crackdown against the law of evidence" src={afterMath1} className={classNames(imageStyles.hover_effect)}/>
                         </div>
                       </div>
                       <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_25_portrait)}>
                         <div id={imageStyles.afterMath2} ref={props.addParallaxAndFadeRef(-4)} className={classNames(imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",1])}>
                            <img alt="Crackdown against the law of evidence" src={afterMath2} className={classNames(imageStyles.hover_effect)} />
                         </div>
                       </div>
                       <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_25_portrait)}>
                         <div id={imageStyles.afterMath3} ref={props.addParallaxAndFadeRef(4)} className={classNames(imageStyles.laathi_gallery, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",2])}>
                           <img alt="Crackdown against the law of evidence" src={afterMath3} className={classNames(imageStyles.hover_effect)}/>
                         </div>
                       </div>
                       <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_50)}>
                         <div id={imageStyles.afterMath4} ref={props.addParallaxAndFadeRef(-4)} className={classNames(imageStyles.laathi_gallery, imageStyles.laathi_gallery_margined, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",3])}>
                           <img alt="Crackdown against the law of evidence" src={afterMath4} className={classNames(imageStyles.hover_effect)}/>
                         </div>
                       </div>
                       <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_40)}>
                         <div ref={props.addParallaxAndFadeRef(5)} className={classNames(imageStyles.laathi_gallery, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",4])}>
                           <img alt="Crackdown against the law of evidence" src={afterMath5} className={classNames(imageStyles.hover_effect)}/>
                         </div>
                       </div>
                     </HorizontalScroll>
                    </div>
                    <Overlay
                      oId="1"
                      displayedOverlay={props.displayedOverlay}
                      closeOverlay={props.closeOverlay}
                      setDisplayedOverlay={props.setDisplayedOverlay}
                      slides={
                        [{
                          description : <span>Daily <i>Jang</i> covers WAF's protest against the 'Law of evidence' - 13 Feb 1983</span>,
                          title : "Sample Title",
                          source : "",
                          render : ()=> <img alt="Daily Jang - 13 Feb 1983" src={afterMath1} style={window.innerHeight > 675 ? {width: '50%', marginLeft: '25%'} : {width: '40%', marginLeft: '30%'}}></img>,
                        },
                        {
                          description : <span>Daily <i>Jang</i> - 13 Feb 1983</span>,
                          title : "Sample Title2",
                          source : "",
                          render : ()=> <img alt="Daily Jang - 13 Feb 1983" src={afterMath2} style={window.innerHeight > 675 ? {width: '60%', marginLeft: '20%'} : {width: '55%', marginLeft: '22.5%'}}></img>,
                        },
                        {
                          description : <span>An editorial in Daily <i>Jang</i> about the protests - 14 Feb 1983</span>,
                          title : "Sample Title2",
                          source : "",
                          render : ()=> <img alt="Daily Jang - 14 Feb 1983" src={afterMath3} style={window.innerHeight > 675 ? {width: '40%', marginLeft: '30%'} : {width: '36%', marginLeft: '37%'}}></img>,
                        },
                        {
                          description : <span>Daily <i>Jang</i> - 14 Feb 1983</span>,
                          title : "Sample Title2",
                          source : "",
                          render : ()=> <img alt="Daily Jang - 14 Feb 1983" src={afterMath4}></img>,
                        },
                        {
                          description : <span>Reaction of Jamat-i-Islami leaders to the protests, published in Daily <i>Jang</i> - 14 Feb 1983</span>,
                          title : "Sample Title2",
                          source : "",
                          render : ()=> <img alt="Daily Jang - 14 Feb 1983" src={afterMath5}></img>,
                        }]
                      }
                    />
                 </div>
               )
             }}
          </Slide>
        ),
        prev : "chapter3slide6",
        next : "chapter4",
        menuInverted : false,
        bottomBarMessage: 'Click images to enlarge'
      }
    }
  },
  "chapter4" : {
    name : "Chapter 4: WAF's Activism",
    slides : {
      "chapter4" : {
        component : (
          <Slide bgImage={Chapter4Title}>
            {(props) => {
              return (
                <div ref={props.addFadeRef} className={slideStyles.slideflex}>
                  <div className={slideStyles.slideContent}>
                    <ChapterTitle
                      inverted
                      chapter_number="4"
                      chapter_title="WAF's Activism"
                      addParallaxAndFadeRef={props.addParallaxAndFadeRef}
                      images={[
                        {image: Post83Title1, id: chTStyles.Post83Title1, shift: 12},
                        {image: Post83Title2, id: chTStyles.Post83Title2, shift: -18},
                        {image: WAF_logo, id: chTStyles.WafLogo, shift: 17}
                      ]}
                    />
                  </div>
                  <div className={chapter_title_styles.bottom_gradient} style={{background: 'linear-gradient(to bottom, rgba(30,87,153,0) 0%,rgba(53,68,75,0.48) 48%,rgba(53,68,75,0.97) 97%,rgba(53,68,75,1) 100%)'}}></div>
                </div>
              )}}
          </Slide>
        ),
        prev : "chapter3slide7",
        next : "chapter4slide1",
        menuInverted : true,
        hideChapterNumber: true,
        bottomBarMessage: ''
      },
      "chapter4slide1" : {
        slideName : "WAF’s activism post 1983",
        component : (
          <Slide bgImage={Slide11Back}>
            {(props) => {
              return (
                <div className={slideStyles.slideflex}>
                  <SlideHeading title="WAF’s activism post 1983" desc="The Women’s Action Forum continued their struggle for upholding women’s rights. Here, we present a few photos of WAF’s activism post 1983."/>
                  <div className={slideStyles.galleryChevrons_container}>
                    <p ref={props.addFadeRef} className={slideStyles.galleryTitle}>Gallery</p>
                    <div onClick={props.moveBackward} className={slideStyles.prevSlideChev}><MdChevronLeft/></div>
                    <div onClick={props.moveForward} className={slideStyles.nextSlideChev}><MdChevronRight/></div>
                  </div>
                  <div className={slideStyles.slideContent}>
                    <HorizontalScroll
                      scrollContainerRef={props.scrollContainerRef}
                      xPos={props.xPos}>
                      <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_50)}>
                        <div id={imageStyles.post831} ref={props.addParallaxAndFadeRef(6)} className={classNames(imageStyles.rotate_0_dec_50_neg, imageStyles.laathi_gallery, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",0])}>
                          <img alt="A procession of WAF activists at the 10th anniversary march of the February 1983 sit-in" src={post83Gallery1} className={classNames(imageStyles.hover_effect)}/>
                        </div>
                      </div>
                      <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_50)}>
                        <div id={imageStyles.post832} ref={props.addParallaxAndFadeRef(-7)} className={classNames(imageStyles.rotate_0_dec_75, imageStyles.laathi_gallery, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",1])}>
                          <img alt="" src={post83Gallery2} className={classNames(imageStyles.hover_effect)}/>
                        </div>
                      </div>
                      <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_50)}>
                        <div id={imageStyles.post833} ref={props.addParallaxAndFadeRef(6)} className={classNames(imageStyles.rotate_0_dec_50_neg, imageStyles.laathi_gallery, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",2])}>
                          <img alt="" src={Post83Title2} className={classNames(imageStyles.hover_effect)}/>
                        </div>
                      </div>
                      <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_50)}>
                        <div id={imageStyles.post834} ref={props.addParallaxAndFadeRef(-5)} className={classNames(imageStyles.laathi_gallery, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",3])}>
                          <img alt="In 1986, when two young women were raped and murdered in Karachi, WAF Lahore members protested by burning dupattas at the press club." src={post83Gallery4} className={classNames(imageStyles.hover_effect)}/>
                        </div>
                      </div>
                      <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_50)}>
                        <div id={imageStyles.post835} ref={props.addParallaxAndFadeRef(6)} className={classNames(imageStyles.rotate_0_dec_75, imageStyles.laathi_gallery, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",4])}>
                          <img alt="WAF members protest against the 15th constitutional amendment (so called Shariat Bill) during Nawaz Sharif’s government (1998)" src={post83Gallery5} className={classNames(imageStyles.hover_effect)}/>
                        </div>
                      </div>
                      <div ref={props.addParallaxAndFadeRef(-5)} className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_50)}>
                        <div id={imageStyles.post836} className={classNames(imageStyles.rotate_0_dec_75, imageStyles.laathi_gallery, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",5])}>
                          <img alt="" src={post83Gallery6} className={classNames(imageStyles.hover_effect)}/>
                        </div>
                      </div>
                    </HorizontalScroll>
                  </div>
                  <Overlay
                    oId="1"
                    displayedOverlay={props.displayedOverlay}
                    closeOverlay={props.closeOverlay}
                    setDisplayedOverlay={props.setDisplayedOverlay}
                    slides={
                      [{
                        description : "A procession of WAF activists at the 10th anniversary march of the February 1983 sit-in",
                        title : "WAF protests against banning of women from sports and co-education institutions",
                        source : "The Second Floor's (T2F) Facebook page",
                        render : ()=> <img alt="A procession of WAF activists at the 10th anniversary march of the February 1983 sit-in" src={post83Gallery1}></img>,
                      },
                      {
                        description : "A demonstration by WAF in Lahore",
                        title : "Sample Title2",
                        source : "The Second Floor's (T2F) Facebook page",
                        render : ()=> <img alt="" src={post83Gallery2}></img>,
                      },
                      {
                        description : "A demonstration by WAF in Lahore",
                        title : "Sample Title2",
                        source : "The Second Floor's (T2F) Facebook page",
                        render : ()=> <img alt="" src={Post83Title2}></img>,
                      },
                      {
                        description : "In 1986, when two young women were raped and murdered in Karachi, WAF Lahore members protested by burning dupattas at the press club.",
                        title : "WAF protests against banning of women from sports and co-education institutions",
                        source : "Twitter: Aurat March Khi",
                        originalLink: 'https://twitter.com/AuratMarchKHI/status/1234736347342147584',
                        render : ()=> <img alt="In 1986, when two young women were raped and murdered in Karachi, WAF Lahore members protested by burning dupattas at the press club." src={post83Gallery4}></img>,
                      },{
                        description : "WAF members protest against the 15th constitutional amendment (so called Shariat Bill) during Nawaz Sharif’s government (1998)",
                        title : "Sample Title2",
                        source : "The Second Floor's (T2F) Facebook page",
                        render : ()=> <img alt="WAF members protest against the 15th constitutional amendment (so called Shariat Bill) during Nawaz Sharif’s government (1998)" src={post83Gallery5}></img>,
                      },{
                        description : <p>A protest by WAF members. Verses from the WAF anthem (right) by Jalib and the feminist poem <i>chadar aur char diwari</i> (left) by Fahmida Riaz can be seen on the placards of activists</p>,
                        title : "Sample Title2",
                        source : "The Second Floor's (T2F) Facebook page",
                        render : ()=> <img alt="" src={post83Gallery6}></img>,
                      }]
                    }
                  />
                </div>
              )}}
          </Slide>
        ),
        prev : "chapter4",
        next : "chapter4slide2",
        menuInverted : false,
        bottomBarMessage: 'Click images to enlarge'
      },
      "chapter4slide2" : {
        slideName : "Art of Resistance: Lala Rukh - Slide 1",
        component : (
          <Slide bgImage={SlideLala}>
            {(props) => {
              return (
                <div className={slideStyles.slideflex}>
                  <SlideHeading inverted title="Art of Resistance: Lala Rukh"/>
                  <div className={slideStyles.slideContent}>
                    <Layout layoutClassName="layout_flexed">
                      <div ref={props.addParallaxAndFadeRef(8)}  className={classNames(layoutStyles.layout_container, layoutStyles.container_52, layoutStyles.align_center, layoutStyles.justify_center)}>
                        <p className={classNames(slideStyles.slidePara, slideStyles.white)}>In the bottom row of the iconic group photo from the 1982 WAF National Convention Lahore lies Lala Rukh, an artist who also taught at Lahore’s National College of Arts. As part of her activism for WAF, she designed many posters and screen prints which reflect the ethos of the Women’s Action Forum. After Lala’s death in 2017, her work would also be added to the collection at the famous Metropolitan Museum of the Art in New York.</p>
                      </div>
                      <div ref={props.addParallaxAndFadeRef(20)} className={classNames(layoutStyles.layout_container, layoutStyles.container_48, layoutStyles.align_center, layoutStyles.justify_center)}>
                        <HotspotImage pulsating marginBottom="0px" width="75%" imageBorderClass={slideStyles.imgBorder} bordered rotate imageRotateClass={imageStyles.rotate_0_dec_75}  imageSrc={lalaArchives} vbx='800' vby='655' r='15' hotspots={[{x: '425', y: '430', fill: 'white', opacity: '0.5', name: 'Lala Rukh', text: `Lala Rukh (1948–2017) was an eminent artist who also taught at Lahore's National College of Arts.  Lala Rukh’s work has also been added to the collection of the famous Metropolitan Museum of the art. As part of her activism with WAF, she designed many posters for it’s events over the years.`}]} ></HotspotImage>
                      </div>
                    </Layout>
                  </div>
                </div>
              )}}
          </Slide>
        ),
        prev : "chapter4slide1",
        next : "chapter4slide3",
        menuInverted : true,
        bottomBarMessage: 'Click images to enlarge'
      },
      "chapter4slide3" : {
        slideName : "Art of Resistance: Lala Rukh - Slide 2",
        component : (
          <Slide bgImage={SlideLalaGalleryBack}>
            {(props) => {
              return (
                <div className={slideStyles.slideflex}>
                  <div ref={props.addFadeRef}>
                  <SlideHeading inverted title="Art of Resistance: Lala Rukh"/>
                  </div>
                  <div className={slideStyles.galleryChevrons_container}>
                    <p className={classNames(slideStyles.galleryTitle, slideStyles.white)}>Gallery</p>
                    <div onClick={props.moveBackward} className={classNames(slideStyles.prevSlideChev, slideStyles.invertedChev)}><MdChevronLeft/></div>
                    <div onClick={props.moveForward} className={classNames(slideStyles.nextSlideChev, slideStyles.invertedChev)}><MdChevronRight/></div>
                  </div>
                  <div className={slideStyles.slideContent}>
                    <HorizontalScroll
                      scrollContainerRef={props.scrollContainerRef}
                      xPos={props.xPos}>
                        <div ref={props.addParallaxAndFadeRef6} className={slideStyles.galleryItem_container}>
                          <div id={imageStyles.lalaGallery1} className={classNames(imageStyles.lala_gallery, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",0])}>
                            <img alt="" className={classNames(imageStyles.hover_effect)} src={lalaGallery1}/>
                          </div>
                        </div>
                        <div ref={props.addParallaxAndFadeRef(-7)} className={slideStyles.galleryItem_container}>
                          <div id={imageStyles.lalaGallery2} className={classNames(imageStyles.lala_gallery, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",1])}>
                            <img alt="" className={classNames(imageStyles.hover_effect)} src={lalaGallery2}/>
                          </div>
                        </div>
                        <div ref={props.addParallaxAndFadeRef(5)} className={slideStyles.galleryItem_container}>
                          <div id={imageStyles.lalaGallery3} className={classNames(imageStyles.lala_gallery, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",2])}>
                            <img alt="" className={classNames(imageStyles.hover_effect)} src={lalaGallery3}/>
                          </div>
                        </div>
                        <div ref={props.addParallaxAndFadeRef(-6)} className={slideStyles.galleryItem_container}>
                          <div id={imageStyles.lalaGallery4} className={classNames(imageStyles.lala_gallery, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",3])}>
                            <img alt="" className={classNames(imageStyles.hover_effect)} src={lalaGallery4}/>
                          </div>
                        </div>
                        <div ref={props.addParallaxElsRef(5)} className={slideStyles.galleryItem_container}>
                          <div id={imageStyles.lalaGallery5} className={classNames(imageStyles.lala_gallery, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",4])}>
                            <img alt="" className={classNames(imageStyles.hover_effect)} src={lalaGallery5}/>
                          </div>
                        </div>
                        <div ref={props.addParallaxElsRef(-7)} className={slideStyles.galleryItem_container}>
                          <div id={imageStyles.lalaGallery6} className={classNames(imageStyles.lala_gallery, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",5])}>
                            <img alt="" className={classNames(imageStyles.hover_effect)} src={lalaGallery6}/>
                          </div>
                        </div>
                    </HorizontalScroll>
                  </div>
                  <Overlay
                    oId="1"
                    displayedOverlay={props.displayedOverlay}
                    closeOverlay={props.closeOverlay}
                    setDisplayedOverlay={props.setDisplayedOverlay}
                    slides={
                      [{
                        description : "Demanding equal rights and striving for it by unshackling handcuffs symbolizing confining of women to their homes draped in a veil of morality imposed on their bodies.",
                        title : "Sample Title",
                        source : "documenta14.de",
                        render : ()=> <img alt="" src={lalaGallery1} style={window.innerHeight > 675 ? {width: '67%', marginLeft: '16.5%'} : {width: '60%', marginLeft: '20%'}}></img>,
                      },
                      {
                        description : "An invitation to the ten year anniversary celebration of the sit-in of February 1983. Images of women being lathi charged in 1983 can also be seen.",
                        title : "Sample Title2",
                        source : "documenta14.de",
                        render : ()=> <img alt="" src={lalaGallery2} style={window.innerHeight > 675 ? {width: '58%', marginLeft: '21%'} : {width: '52%', marginLeft: '24%'}}></img>,
                      },
                      {
                        description : "Poster titled, ‘Crime against women’ presents a collage of news clippings of incidents of violence and injustice against women.",
                        title : "Sample Title2",
                        source : "documenta14.de",
                        render : ()=> <img alt="" src={lalaGallery3} style={window.innerHeight > 675 ? {width: '64%', marginLeft: '18%'} : {width: '56%', marginLeft: '22%'}}></img>,
                      },
                      {
                        description : "A calendar from the year 1985 publicizing Women’s Action Forum.",
                        title : "Sample Title2",
                        source : "documenta14.de",
                        render : ()=> <img alt="" src={lalaGallery4} style={window.innerHeight > 675 ? {width: '67%', marginLeft: '16.5%'} : {width: '60%', marginLeft: '20%'}}></img>,
                      },{
                        description : "An image critiquing the nexus of patriarchy, capitalism and religiosity in subjugating the minds and bodies of women.",
                        title : "Sample Title2",
                        source : "documenta14.de",
                        render : ()=> <img alt="" src={lalaGallery5} style={window.innerHeight > 675 ? {width: '64%', marginLeft: '18%'} : {width: '56%', marginLeft: '22%'}}></img>,
                      },{
                        description : <p><p>A publicity poster designed by Lala Rukh for the first WAF Convention held in 1982 in Lahore. In the background, a statement repeats itself: </p><p>Translation: ‘It is a crime against humanity that our women are confined to the four walls of their houses like prisoners’</p><p>In the foreground, Fatima Jinnah is seen, alongside Muhammad Ali Jinnah, representing women leadership in the nation’s history</p></p>,
                        title : "Sample Title2",
                        source : "artasiapacific.com",
                        render : ()=> <img alt="" src={lalaGallery6} style={window.innerHeight > 675 ? {width: '67%', marginLeft: '16.5%'} : {width: '60%', marginLeft: '20%'}}></img>,
                      }]
                    }
                  />
                </div>
              )}}
          </Slide>
        ),
        prev : "chapter4slide2",
        next : "chapter4slide4",
        menuInverted : true,
        bottomBarMessage: 'Click images to enlarge'
      },
      "chapter4slide4" : {
        slideName : "Women of WAF - Slide 1",
        component : (
          <Slide bgImage={Slide12Back}>
              {(props) => {
                return (
                  <div className={slideStyles.slideflex}>
                    <div className={slideStyles.slideContent}>
                      <Layout layoutClassName="layout_flexed">
                        <div className={layoutStyles.layout_100} ref={props.addParallaxAndFadeRef(5)}>
                          <SlideHeading noPadding title="Women of WAF" desc="Many of WAF’s members continued to fight for women’s rights throughout their lives. In the next slide, you can browse their profiles by interacting with an iconic photo from the first WAF convention in Lahore (1982)"/>
                        </div>
                      </Layout>
                    </div>
                  </div>
              )}}
          </Slide>
        ),
        prev : "chapter4slide3",
        next : "chapter4slide5",
        bottomBarMessage: 'Click images to enlarge'
      },
      "chapter4slide5" : {
        slideName : "Women of WAF - Slide 2",
        component : (
          <Slide bgImage={Slide13Back}>
              {(props) => {
                return (
                  <div className={slideStyles.slideflex}>
                  <SlideHeading inverted title="Women of WAF"/>
                    <div className={slideStyles.slideContent}>
                      <Layout layoutClassName="layout_flexed">
                        <div ref={props.addParallaxAndFadeRef(5)} className={layoutStyles.layout_100}>
                          <HotspotImage width={window.innerHeight > 675 ? "50%" : "43%"} marginBottom={window.innerHeight > 675 ? "50px" : '0px'} imageSrc={lalaArchives} vbx='800' vby='655' r='8'
                            hotspots={[{x: '425', y: '430', fill: '#bdbdbd', stroke: '#606060', opacity: '0.8', name: 'Lala Rukh', text: `Lala Rukh (1948–2017) was an eminent artist who also taught at Lahore's National College of Arts.  Lala Rukh’s work has also been added to the collection of the famous Metropolitan Museum of the Art. As part of her activism with WAF, she designed many posters for it’s events over the years.`},
                            {x: '200', y: '170', fill: '#bdbdbd', stroke: '#606060', opacity: '0.8', name: 'Najma Sadeque', text: `One of the founding members of the Women’s Action Forum, Najma Sadeque (1943 - 2015) was a leading woman journalist, author, human rights activist, an artist, an environmentalist and a painter. She also founded the Shirkat Gah in 1975, a women's NGO that worked towards advocating and promoting women’s rights and empowerment. `},
                            {x: '340', y: '250', fill: '#bdbdbd', stroke: '#606060', opacity: '0.8', name: 'Farida Shaheed', text: `Farida Shaheed is a Pakistani sociologist and feminist human rights activist. In 2012, she was appointed the United Nations Special Rapporteur in the field of cultural rights. She is also a senior member at Shirkat Gah, the organization that lay the foundation for WAF.`},
                            {x: '440', y: '250', fill: '#bdbdbd', stroke: '#606060', opacity: '0.8', name: 'Ghazala Rehman', text: `Ghazala Rahman Rafiq is an educationist, and social reformer from Karachi who also founded the Sindh Abhyas Academy at SZABIST.`},
                            {x: '540', y: '250', fill: '#bdbdbd', stroke: '#606060', opacity: '0.8', name: 'Fareeha Zafar', text: <p>One of SAHE’s (Society for the Advancement of Education) founding members and its director for 10 years. She is also the editor of the book, <i>Finding Our Way: Women in Pakistan</i>.</p>},
                            {x: '650', y: '250', fill: '#bdbdbd', stroke: '#606060', opacity: '0.8', name: 'Nighat Said Khan', text: `A Pakistani feminist activist, researcher and author, Nighat Said Khan is the director and founder of the Applied Socio-Economic Research (ASR) Resource Centre and a founding member of the Women's Action Forum.`},
                            {x: '710', y: '300', fill: '#bdbdbd', stroke: '#606060', opacity: '0.8', name: 'Aban Markar-Kabraji', text: 'Aban Markar-Kabraji is a biologist and scientist of Parsi origin. In addition to her activism with WAF, she has also been recognized for her services towards environmental conservation, both nationally and internationally. She is the current Regional Director of the Asia Regional Office at the IUCN, the International Union for Conservation of Nature. Aban Markar-Kabraji was also awarded the Tamgha-e-Imtiaz in 2018 for her services to the state of environmental awareness in Pakistan.'},
                            {x: '125', y: '300', fill: '#bdbdbd', stroke: '#606060', opacity: '0.8', name: 'Samina Rahman', text: `A founding member of Women’s Action Forum (WAF) Lahore, Samina Rahman has been a teacher, educationist and human rights activist for over four decades. She taught at the Quaid-e-Azam University and University of the Punjab, before establishing Lahore Grammar School in 1979 with a group of like-minded women, where she still works.`},
                            {x: '240', y: '340', fill: '#bdbdbd', stroke: '#606060', opacity: '0.8', name: 'Khawar Mumtaz', text: `A women's rights activist, university lecturer and author, Khawar Mumtaz continued her activism and served as Chairwoman of the National Commission on the Status of Women, a federal government agency established to examine and uphold laws and policies to safeguard women’s rights.`},
                            {x: '500', y: '360', fill: '#bdbdbd', stroke: '#606060', opacity: '0.8', name: 'Hilda Saeed', text: `A microbiologist-turned-women’s-rights activist, Hilda Saeed is the current chairperson of Shirkat Gah, the organization that lay the foundation for WAF. She went on to fight for improved maternal and reproductive health for women.`},
                            {x: '620', y: '360', fill: '#bdbdbd', stroke: '#606060', opacity: '0.8', name: 'Nigar Ahmad', text: `Nigar Ahmad (1945 - 2017), an eminent member of WAF Lahore would go on to found Aurat foundation, a leading women’s rights NGO in Pakistan in her later years.`}]}
                          ></HotspotImage>
                        </div>
                      </Layout>
                    </div>
                  </div>
              )}}
          </Slide>
        ),
        prev : "chapter4slide4",
        next : "chapter4slide6",
        menuInverted : true,
        bottomBarMessage: 'Click circles to interact'
      },
      "chapter4slide6" : {
        slideName : "Aurat March",
        component : (
          <Slide bgImage={AuratMarchBack}>
              {(props) => {
                return (
                  <div className={slideStyles.slideflex}>
                    <SlideHeading title="Aurat March" desc="The WAF continues to march on. A new generation of Pakistani feminists and rights activists have joined the field. Like WAF activists - who led a political movement against the most brutal military dictator in Pakistan’s history - the young activists have similarly taken up political fight at a time when civil liberties are being curtailed, media’s freedom muzzled and a threat is posed to the democratic structure of Pakistan. The Aurat March - in a span of less than three years - has assumed an iconic status. It reverberates with the spirit of WAF’s activism on the streets of Lahore."/>
                    <div className={slideStyles.galleryChevrons_container}>
                      <p ref={props.addFadeRef} className={slideStyles.galleryTitle}>Gallery</p>
                      <div onClick={props.moveBackward} className={slideStyles.prevSlideChev}><MdChevronLeft/></div>
                      <div onClick={props.moveForward} className={slideStyles.nextSlideChev}><MdChevronRight/></div>
                    </div>
                    <div className={slideStyles.slideContent}>
                      <HorizontalScroll
                        scrollContainerRef={props.scrollContainerRef}
                        xPos={props.xPos}>
                        <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_40)}>
                          <div ref={props.addParallaxAndFadeRef(5)} className={classNames(imageStyles.laathi_gallery, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",0])}>
                            <img alt="" src={auratMarch1} className={classNames(imageStyles.hover_effect)}/>
                          </div>
                        </div>
                        <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_40)}>
                          <div ref={props.addParallaxAndFadeRef(-5)} className={classNames(imageStyles.laathi_gallery, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",1])}>
                            <img alt="" src={auratMarch2} className={classNames(imageStyles.hover_effect)}/>
                          </div>
                        </div>
                        <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_33_portrait)}>
                          <div ref={props.addParallaxAndFadeRef(4)} className={classNames(imageStyles.laathi_gallery, imageStyles.effected_image)} onClick={()=> props.setDisplayedOverlay(["1",3])}>
                            <img alt="" src={auratMarch3} className={classNames(imageStyles.hover_effect)}/>
                          </div>
                        </div>
                        <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_40)}>
                          <VideoLink setDisplayedOverlay={props.setDisplayedOverlay} overlayArray={["1",2]} image={auratMarchVideo} imageStyle={{width: '100%', alignSelf: 'center', marginBottom: '5px', cursor: 'pointer'}} linkMessage="Aurat March Lahore 2020 - Highlights video" linkSource="Source: Aurat March"/>
                        </div>

                      </HorizontalScroll>
                    </div>

                    <Overlay
                      oId="1"
                      displayedOverlay={props.displayedOverlay}
                      closeOverlay={props.closeOverlay}
                      setDisplayedOverlay={props.setDisplayedOverlay}
                      slides={
                        [{
                          description : <p><i>Aurat March</i> 2020</p>,
                          title : "",
                          source : "Aurat March",
                          render : ()=> <img alt="" src={auratMarch1}></img>,
                        },
                        {
                          description : <p>While the emphasis towards body politics during the Aurat March marks a shift, it still captures the essence of feminist movements of the past. Pictured here: Nighat Said Khan, a founding member of WAF, holding up a poster supporting the slogan "mera jism meri marzi", that became the unofficial rallying cry of the Aurat March.</p>,
                          title : "Sample Title2",
                          source : "Aurat March",
                          render : ()=> <img alt="" src={auratMarch2}></img>,
                        },
                        {
                          description : <p>Highlights video for <i>Aurat March</i> 2020</p>,
                          title : "Sample Title2",
                          source : "Aurat March Lahore | Youtube",
                          render : ()=> <VideoFrame link='https://www.youtube.com/embed/R-ekMXgX8YA'/>,
                        },
                        {
                          description : <p>Aurat March marked a shift in the mode of feminist politics--moving away from respectability politics of yesteryears to use of humour and confrontational slogans that captured the language of the current generation.</p>,
                          title : "WAF protests against banning of women from sports and co-education institutions",
                          source : "Aurat March",
                          render : ()=> <img alt="" src={auratMarch3} style={window.innerHeight < 675 && {width: '85%', marginLeft: '7.5%'}}></img>,
                        }]
                      }
                    />
                  </div>
              )}}
          </Slide>
        ),
        prev : "chapter4slide5",
        next : "credits",
        menuInverted : false,
        bottomBarMessage: 'Click images to enlarge'
      }
    }
  },
  "credits" : {
    name : "Women Action Forum",
    slides : {
      "credits" : {
        component : (
          <Slide bgImage={ProjectCreditsBack}>
            {(props) => {
              return (
                <div className={slideStyles.slideflex} ref={props.addParallaxAndFadeRef(10)}>
                  <div className={slideStyles.slideContent}>
                    <ProjectCredits
                      disclaimer=<span>These projects are based on research conducted by students for the course <i>Walking in the City: Mapping Everyday Life in Lahore.</i></span>
                      projectName="Political movements in Lahore "
                      studentNames="Usama Liaqat, Syeda Nida Hasan, Syeda Fatima Tehseen, Muhammad Abdullah Niazi, Zarish Shahzad, Amal Arif, Muhammad Asfandyar"
                      supervisor={{name: 'Dr Ali Usman Qasmi', desig: 'Associate Professor (History), Department of Humanities and Social Sciences, LUMS'}}
                      optionalLogo={WAF_logo}
                      description="Under the military rule of General Zia-ul-Haq (1977-1988), the women’s movement emerged in direct opposition to state repression. The Women Action Forum was a crucial part of the movement."
                    />
                  </div>
                </div>
              )}}
          </Slide>
        ),
        prev : "chapter4slide6",
        next : "credits",
        menuInverted : true,
        hideChapterNumber: true,
        bottomBarMessage: '',
        hideVerticalNav: true
      },
    }
  },
}

function topoSortSlides(slides){
  const visitedSet = {};
  const orderArr = [];
  const allSlidesMap = {};

  for(let i in slides){
    for(let j in slides[i].slides){
      allSlidesMap[j] = slides[i].slides[j];
    }
  }

  Object.keys(allSlidesMap).forEach((s)=>{
    topoSortNode(s, allSlidesMap, orderArr, visitedSet)
  })
  return orderArr.reverse().reduce((acc,d,i)=>{
    acc[d] = i;
    return acc;
  },{});
}

function topoSortNode(nodename,nodes, orderArr, visitedSet){
  if(nodename === null || visitedSet[nodename]){
    return orderArr;
  }

  visitedSet[nodename] = true;
  topoSortNode(nodes[nodename].next, nodes, orderArr, visitedSet);
  orderArr.push(nodename);

  return orderArr;
}

const slideOrder = topoSortSlides(slideMap)

const chapterArr = ["chapter1","chapter2","chapter3","chapter4"]

const mobileSlideMap = {
  "home" : {
    name: "Project Home",
    component : (
      <MobileSlide>
        {
          (props)=>{
            return (
              <ProjectTitleMobile
                image={ProjectTitleBack}
                title="Women’s Action Forum"
                optionalLogo={WAF_logo}
                description="Under the military rule of General Zia-ul-Haq (1977-1988), a movement was launched to resist the imposition of regressive laws against women. The Women's Action Forum (WAF) was a crucial part of the movement."
              />
              )
          }
        }
      </MobileSlide>
    )
  },
  "chapter1" : {
    name: "Chapter 1: Background",
    component : (
      <MobileSlide>
        {
          (props)=>{
            return (
              <div>
                <ChapterTitleMobile
                  inverted
                  image={Chapter1Title}
                  chapter_number="1"
                  chapter_title="Background"
                  id={chTStyles.ziaMobileTitle}
                  images={[
                    {image: TitleDawn, id: chTStyles.dawnTitle},
                    {image: Zia, id: chTStyles.ziaSalute}
                  ]}
                  gradient='linear-gradient(to bottom, rgba(30,87,153,0) 0%,rgba(53,68,75,0.48) 48%,rgba(53,68,75,0.97) 97%,rgba(53,68,75,1) 100%)'
                />
                <MobileSectionTitle
                  inverted
                  image={Slide1Back}
                  title="Zia declares Martial Law and Political activity is banned"
                  chapterNumber="CHAPTER 1: BACKGROUND"
                  note="Pictures in the chapter can be clicked for expanded view"
                />
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.increased_padded_top, mobileStyles.increased_padded_bottom)}>
                  <p className={mobileStyles.mobilePara}>After months of protests against Zulfiqar Ali Bhutto led by Pakistan National Alliance (PNA) - a coalition of right-wing political parties - the military under General Zia-ul-Haq seized the opportunity to intervene, ousted the prime minister and imposed martial law in the country.</p>
                  <p className={mobileStyles.mobilePara}>The protests preceding the imposition of martial law was used as a pretext to impose a ban on all sorts of political activities. Amidst acrimonious war of words between the PNA and Pakistan Peoples Party, the military projected itself as a stabilizing force that extinguished the ‘flames of politics’ threatening the country.</p>
                </div>
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.flexed_container, mobileStyles.increased_padded_bottom)}>
                  <div className={mobileStyles.mobile_layout_50}>
                    <img onClick={()=> props.setDisplayedOverlay(["1",0])} id={imageStyles.dawn_zia_martial_law} src={dawnTitle} alt="Title of DAWN Newspaper, July 6 1977" className={mobileStyles.shadowImage}/>
                    <p id={imageStyles.dawn_zia_martial_law} className={mobileStyles.mobileImageDesc}>Title of DAWN Newspaper, July 6 1977</p>
                  </div>
                  <div className={mobileStyles.mobile_layout_50}>
                    <img onClick={()=> props.setDisplayedOverlay(["1",1])} id={imageStyles.comic_zia_martial_law} src={urduCartoon} alt="A newspaper cartoon where the military is projected as a stabilizing force that extinguished the ‘flames of politics’ threatening the country." className={mobileStyles.shadowImage}/>
                    <p id={imageStyles.dawn_zia_martial_law} className={mobileStyles.mobileImageDesc}>A newspaper cartoon where the military is projected as a stabilizing force that extinguished the ‘flames of politics’ threatening the country.</p>
                  </div>
                </div>
                <MobileSectionTitle
                  image={Slide2Mobile}
                  title="Hudood Ordinance"
                  year="1979"
                  chapterNumber="CHAPTER 1: BACKGROUND"
                  note="Pictures in the chapter can be clicked for expanded view"
                />
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.increased_padded_top, mobileStyles.padded_bottom)}>
                  <p className={mobileStyles.mobilePara}>To provide legitimacy to his rule, Zia resorted to the slogan of Islam and transformation of Pakistan into a truly Islamic state. As part of these policies, Zia imposed the Hudud Ordinances in 1979. These added new criminal offences to the penal code of adultery and fornication, with punishments of public floggings, amputation and stoning to death.</p>
                  <p className={mobileStyles.mobilePara}>This law was considered intrinsically misogynistic since its application resulted in women being convicted for adultery/fornication if they reported a case of rape and were unable to produce ‘pious, male witnesses’.</p>
                </div>
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.padded_bottom, mobileStyles.hudoodGalleryButtonHide)}>
                  <div className={mobileStyles.galleryChevrons_container}>
                    <div>
                      <p className={slideStyles.galleryTitle}>Gallery</p>
                    </div>
                    <div style={{display: 'flex', alignItems: 'center'}}>
                      <div onClick={props.moveBackward('1')} className={slideStyles.prevSlideChev}><MdChevronLeft/></div>
                      <div onClick={props.moveForward('1')} className={slideStyles.nextSlideChev}><MdChevronRight/></div>
                    </div>
                  </div>
                </div>
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.gallery_container, mobileStyles.padded_top, mobileStyles.increased_padded_bottom)}>
                  <HorizontalScroll
                    scrollContainerRef={props.addScrollRef('1')}
                    xPos={props.xPos['1']}>
                      <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_50)}>
                        <img className={mobileStyles.shadowImage} id={imageStyles.hudoodOrdinanceMain} onClick={()=> props.setDisplayedOverlay(["2",0])} alt="Public floggings were carried out ostensibly to ‘teach a lesson’ to criminals" src={hudoodFlogging}/>
                      </div>
                      <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_50)}>
                        <img className={mobileStyles.shadowImage} id={imageStyles.hudoodGallery1} onClick={()=> props.setDisplayedOverlay(["2",1])} alt="Public floggings were carried out ostensibly to ‘teach a lesson’ to criminals"  src={hudoodGallery1}/>
                      </div>
                      <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_33)}>
                        <img className={mobileStyles.shadowImage} id={imageStyles.hudoodGallery2} onClick={()=> props.setDisplayedOverlay(["2",2])} alt="Public floggings were carried out ostensibly to ‘teach a lesson’ to criminals"  src={hudoodGallery2}/>
                      </div>
                  </HorizontalScroll>
                </div>
                <MobileSectionTitle
                  image={Slide2Mobile}
                  title="Resistance by women artists"
                  year="1979"
                  chapterNumber="CHAPTER 1: BACKGROUND"
                  note="Pictures in the chapter can be clicked for expanded view"
                />
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.increased_padded_top, mobileStyles.padded_bottom)}>
                  <p className={mobileStyles.mobilePara}><span>Amidst such brutalities, women artists, poets and activists took the lead in organizing resistance against the military junta. This resulted in the penning of some excellent resistance poetry, such as <i>Hum Gunahgar Auratain</i> by Kishwar Nahid and <i>Chadar aur Char Diwari</i> by Fahmida Riaz.</span></p>
                  <AudioLink link="https://rekhtacdn.azureedge.net/Images/SiteImages/Audio/BF417F1F-AD21-4A0C-962A-955050195960.mp3" audio_title="Chadar aur Char Diwari" narrated_by="Azra Naqvi" source="Rekhta"/>
                </div>
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.flexed_container, mobileStyles.increased_padded_bottom)}>
                  <div id = {mobileStyles.fehmida} style={{position: 'relative'}} className={classNames(mobileStyles.mobile_layout_50, mobileStyles.padded_top)}>
                    <div style={{position: 'relative', zIndex: '3'}} className={classNames(imageStyles.rotate_1_dec_0)} onClick={()=> props.setDisplayedOverlay(["3",0])}>
                      <img id={imageStyles.fehmida_portait} src={Fehmida} alt="" className={mobileStyles.shadowImage}/>
                    </div>
                    <div style={{position: 'relative', zIndex: '2'}} className={classNames(imageStyles.rotate_0_dec_75_neg)} onClick={()=> props.setDisplayedOverlay(["3",1])}>
                      <img id={imageStyles.fehmida_landscape} src={Fehmida2} alt="" className={mobileStyles.shadowImage}/>
                    </div>
                  </div>
                  <div className={mobileStyles.mobile_layout_50} id={mobileStyles.video_kishwar}>
                    <VideoLink setDisplayedOverlay={props.setDisplayedOverlay} overlayArray={["3",2]} image={kishwarRekhta} imageStyle={{width: '80%', alignSelf: 'center', marginBottom: '5px', cursor: 'pointer'}} linkMessage="Kishwar Nahid recites her poem" linkSource="Source: Rekhta"/>
                  </div>
                </div>
                <NextChapterTitle
                  image={Chapter2Next}
                  title="Formation of WAF"
                  nextChapter="chapter2"
                  prevChapter="home"
                />
                <Overlay
                  oId="1"
                  displayedOverlay={props.displayedOverlay}
                  closeOverlay={props.closeOverlay}
                  setDisplayedOverlay={props.setDisplayedOverlay}
                  slides={
                    [{
                      description : <p>Title of <i>DAWN</i>, July 6 1977</p>,
                      title : "Sample Title",
                      source : "DAWN",
                      render : ()=> <img id={overlayStyles.dawnMartialLaw} alt="Title of DAWN Newspaper, July 6 1977" src={dawnTitle}></img>,
                    },
                    {
                      description : "The protests preceding the imposition of martial law was used as a pretext to impose a ban on all sorts of political activities. Amidst acrimonious war of words between the PNA and Pakistan Peoples Party, the military projected itself as a stabilizing force that extinguished the ‘flames of politics’ threatening the country.",
                      title : "Sample Title2",
                      source : <i>Nawa-i-Waqt</i>,
                      render : ()=> <img id={overlayStyles.martialLawCartoon} alt="A newspaper cartoon where the military is projected as a stabilizing force that extinguished the ‘flames of politics’ threatening the country." src={urduCartoon}></img>,
                    }]
                  }
                />
                <Overlay
                  oId="2"
                  displayedOverlay={props.displayedOverlay}
                  closeOverlay={props.closeOverlay}
                  setDisplayedOverlay={props.setDisplayedOverlay}
                  slides={
                    [{
                      description : "Public floggings were carried out ostensibly to ‘teach a lesson’ to criminals, but primarily to stifle any dissent or political opposition to Zia’s military regime.",
                      title : "Hudood Ordinance",
                      source : "DAWN",
                      render : ()=> <img id={overlayStyles.hudoodGallery1} alt="Public floggings were carried out ostensibly to ‘teach a lesson’ to criminals"  src={hudoodFlogging}></img>,
                    },
                    {
                      description : "Public floggings were carried out ostensibly to ‘teach a lesson’ to criminals, but primarily to stifle any dissent or political opposition to Zia’s military regime.",
                      title : "Hudood Ordinance",
                      source : "DAWN",
                      render : ()=> <img id={overlayStyles.hudoodGallery2} alt="Public floggings were carried out ostensibly to ‘teach a lesson’ to criminals"  src={hudoodGallery1}></img>,
                    },
                    {
                      description : "Public floggings were carried out ostensibly to ‘teach a lesson’ to criminals, but primarily to stifle any dissent or political opposition to Zia’s military regime.",
                      title : "Hudood Ordinance",
                      source : "DAWN",
                      render : ()=> <img id={overlayStyles.hudoodGallery3} alt="Public floggings were carried out ostensibly to ‘teach a lesson’ to criminals"  src={hudoodGallery2}></img>,
                    }]
                  }
                />
                <Overlay
                  oId="3"
                  displayedOverlay={props.displayedOverlay}
                  closeOverlay={props.closeOverlay}
                  setDisplayedOverlay={props.setDisplayedOverlay}
                  slides={
                    [{
                      description : <p>Kishwar Nahid</p>,
                      title : "Fehmida 1",
                      source : "alchetron.com",
                      render : ()=> <img alt="" id={overlayStyles.fehmida} src={Fehmida}></img>,
                    },
                    {
                      description : <p>Fahmida Riaz</p>,
                      title : "Fehmida 2",
                      source : "DAWN",
                      render : ()=> <img alt="" id={overlayStyles.fehmida2} src={Fehmida2}></img>,
                    },
                    {
                      description : <p>Kishwar Nahid recites <i>Hum Gunahgar Auratain</i></p>,
                      title : "Video 1",
                      source : "DAWN",
                      render : ()=>  <VideoFrame link='https://www.youtube.com/embed/HOdcNBzCJuQ'/>,
                    }]
                  }
                />
              </div>
            )
          }
        }
      </MobileSlide>
    ),
    menuInverted : true,
  },
  "chapter2" : {
    name: "Chapter 2 : Formation of WAF",
    component : (
      <MobileSlide>
        {
          (props)=>{
            return (
              <div>
                <ChapterTitleMobile
                  inverted
                  image={Chapter2Title}
                  chapter_number="2"
                  chapter_title="Formation of WAF"
                  images={[{image: WafBanner, id: chTStyles.wafBanner}]}
                  gradient='linear-gradient(to bottom, rgba(30,87,153,0) 0%,rgba(53,68,75,0.48) 48%,rgba(53,68,75,0.97) 97%,rgba(53,68,75,1) 100%)'
                />
                <MobileSectionTitle
                  image={Slide6Back}
                  title="The impetus for founding WAF"
                  year="1981"
                  inverted
                  chapterNumber="CHAPTER 2: FORMATION OF WAF"
                  note="Pictures in the chapter can be clicked for expanded view"
                />
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.increased_padded_top, mobileStyles.padded_bottom)}>
                  <p className={mobileStyles.mobilePara}>The first conviction under the Hudud Ordinance was of a couple - Fahmida and Allah Bux - who had eloped to get married. Fahmida’s family filed a case of abduction against Allah Bux. The couple was caught and charged with <i>zina</i> (fornication) despite being married. Allah Bux was sentenced to death by stoning, and Fahmida, a minor, was awarded 100 stripes in public.</p>
                  <p className={mobileStyles.mobilePara}>This event sparked an outrage amongst the members of Shirkat Gah, an organization of women activists who met in Lahore to discuss the kinds of action that could be taken. It was at this point that the Women's Action Forum came into being as a platform for women to raise voices against gender-based discrimnation.</p>
                </div>
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_50, mobileStyles.mobile_layout_50_centered, mobileStyles.padded_bottom)}>
                  <VideoLink setDisplayedOverlay={props.setDisplayedOverlay} overlayArray={["3",0]} image={hildaMedia} imageStyle={{marginBottom: '20px', cursor: 'pointer', width: '100%', alignSelf: 'center',}} linkMessage="Hilda Saeed talks about the formation of WAF" linkSource="Source: Stories beyond borders, Bolo Bhi"/>
                </div>
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.padded_bottom)}>
                  <p className={mobileStyles.mobilePara}>A meeting of <i>Shirkat Gah</i> was called in Lahore about the Fehmida and Allah Bux case.</p>
                </div>
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.padded_bottom)}>
                  <MobileQuote quote="It was on an afternoon in September 1981 that Aban Marker [of Shirkatgah] called. She told me about the distressed call she had just received from Najma Sadeque regarding the case of Fahmida-Allah Bux. I remember to this day the faces of the women around the table that evening when we met at Aban’s. Distressed yet determined." source="Zohra Yusuf, a founding WAF member" sourceImage={zohra}></MobileQuote>
                </div>
                <MobileSectionTitle
                  image={Chapter2Next}
                  title="First WAF Convention"
                  year="1982"
                  chapterNumber="CHAPTER 2: FORMATION OF WAF"
                  note="Pictures in the chapter can be clicked for expanded view"
                />
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.increased_padded_top, mobileStyles.increased_padded_bottom)}>
                  <p className={mobileStyles.mobilePara}>WAF holds its first convention in Lahore. The convention was instrumental in formalizing WAF as an organization.</p>
                </div>
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.flexed_container, mobileStyles.increased_padded_bottom)}>
                  <div className={mobileStyles.mobile_layout_50}>
                    <img onClick={()=> props.setDisplayedOverlay(["1",0])} id={imageStyles.conventionOne} src={nationalConv} alt="A large group of women and children pictured at the ‘First WAF Convention’ held in Lahore (1982)" className={mobileStyles.shadowImage}/>
                    <p id={imageStyles.conventionOne} className={mobileStyles.mobileImageDesc}>A large group of women and children pictured at the ‘First WAF Convention’ held in Lahore (1982)</p>
                  </div>
                  <div className={mobileStyles.mobile_layout_50}>
                    <img onClick={()=> props.setDisplayedOverlay(["1",1])} id={imageStyles.conventionTwo} src={lalaArchives} alt="Prominent members of WAF pictured at the ‘First WAF Convention’ held in Lahore (1982) " className={mobileStyles.shadowImage}/>
                    <p id={imageStyles.conventionTwo} className={mobileStyles.mobileImageDesc}>Prominent members of WAF pictured at the ‘First WAF Convention’ held in Lahore (1982) </p>
                  </div>
                </div>

                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.flexed_container, mobileStyles.increased_padded_bottom)}>
                  <div className={classNames(mobileStyles.mobile_layout_70, mobileStyles.centered_columned)}>
                    <p className={mobileStyles.mobilePara}>In the background of the photo (to the left) taken from the first WAF convention in Lahore, a poster can be seen with a repeating statement: Translation: ‘It is a crime against humanity that our women are confined to the four walls of their houses like prisoners’</p>
                  </div>
                  <div className={mobileStyles.mobile_layout_30}>
                    <img onClick={()=> props.setDisplayedOverlay(["2",0])} id={imageStyles.conventionTwo} src={lalaGallery6} alt="Prominent members of WAF pictured at the ‘First WAF Convention’ held in Lahore (1982) " className={mobileStyles.shadowImage}/>
                    <p id={imageStyles.conventionTwo} className={mobileStyles.mobileImageDesc}>Prominent members of WAF pictured at the ‘First WAF Convention’ held in Lahore (1982) </p>
                  </div>
                </div>
                <NextChapterTitle
                  image={Chapter3Next}
                  title="Resistance against the law of evidence"
                  nextChapter="chapter3"
                  prevChapter="chapter1"
                />

                <Overlay
                  oId="1"
                  displayedOverlay={props.displayedOverlay}
                  closeOverlay={props.closeOverlay}
                  setDisplayedOverlay={props.setDisplayedOverlay}
                  slides={
                    [{
                      description : "A large group of women and children pictured at the ‘First WAF Convention’ held in Lahore (1982)",
                      title : "Sample Title",
                      source : "The Second Floor's (T2F) Facebook page",
                      render : ()=> <img id={overlayStyles.conventionOne} alt="First convention of WAF held in Lahore" src={nationalConv}></img>,
                    },
                    {
                      description : "Prominent members of WAF pictured at the ‘First WAF Convention’ held in Lahore (1982) ",
                      title : "Sample Title2",
                      source : "Women's Action Forum Lahore's Facebook page",
                      render : ()=> <img id={overlayStyles.conventionTwo} alt="First convention of WAF held in Lahore" src={lalaArchives}></img>,
                    }]
                  }
                />

                <Overlay
                  oId="2"
                  displayedOverlay={props.displayedOverlay}
                  closeOverlay={props.closeOverlay}
                  setDisplayedOverlay={props.setDisplayedOverlay}
                  slides={
                    [{
                      description : <p><p>A publicity poster from the ‘First WAF Convention’ held in Lahore (1982).</p> <p>In the background a recurring statement can be seen: Translation:  ‘It is a crime against humanity that our women are confined to the four walls of their houses like prisoners’.</p><p> In the foreground, Fatima Jinnah is seen, alongside Muhammad Ali Jinnah, representing women leadership in the nation’s history. The poster was designed by Lala Rukh, a prominent WAF member and an artist from Lahore.</p></p>,
                      title : "Sample Title2",
                      source : <span>artasiapacific.com</span>,
                      render : ()=> <img id={overlayStyles.lalaPosterConvention} alt="Poster from the first waf convention in Lahore made by lala rukh" src={lalaGallery6}></img>,
                    }]
                  }
                />

                <Overlay
                  oId="3"
                  displayedOverlay={props.displayedOverlay}
                  closeOverlay={props.closeOverlay}
                  setDisplayedOverlay={props.setDisplayedOverlay}
                  slides={
                    [{
                      description : "Hilda Saeed talks about the formation of WAF",
                      title : "Video 1",
                      source : "Stories Beyond Borders, Bolo Bhi",
                      render : ()=>  <VideoFrame link='https://www.youtube.com/embed/OfqIYixpVWc'/>,
                    }]
                  }
                />
              </div>
            )
          }
        }
      </MobileSlide>
    ),
    menuInverted : true,
  },
  "chapter3" : {
    name: "Chapter 3: Resistance against the law of evidence",
    component : (
      <MobileSlide>
        {
          (props)=>{
            return (
              <div>
                <ChapterTitleMobile
                  inverted
                  image={Chapter3Title}
                  chapter_number="3"
                  id={chTStyles.kalayKanoon}
                  chapter_title="Resistance against the law of evidence"
                  images={[{image: LalaTrimm, id: chTStyles.lalaTrim}]}
                  gradient='linear-gradient(to bottom, rgba(30,87,153,0) 0%,rgba(53,68,75,0.48) 48%,rgba(53,68,75,0.97) 97%,rgba(53,68,75,1) 100%)'
                />
                <MobileSectionTitle
                  image={Chapter3Next}
                  title="Sit in against the law of evidence"
                  chapterNumber="CHAPTER 3: RESISTANCE AGAINST THE LAW OF EVIDENCE"
                  note="Pictures in the chapter can be clicked for expanded view"
                />
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.increased_padded_top, mobileStyles.increased_padded_bottom)}>
                  <p className={mobileStyles.mobilePara}><i>Qanun-i-Shahadat</i> or the law of evidence was another regressive law introduced by the Zia regime in the name of Islamization. According to the law, the testimony of two women was equivalent to that of one man. On 12 February 1983, WAF, along with the Pakistan Women Lawyers, gave a call to march to the High Court with a petition against the then proposed Law of Evidence. The sit-in begins on the Hall Road.</p>
                </div>
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.flexed_container, mobileStyles.increased_padded_bottom)}>
                  <div className={mobileStyles.mobile_layout_50}>
                    <img onClick={()=> props.setDisplayedOverlay(["1",0])} id={imageStyles.sitin1} src={sitin1} alt="Sit in at the Hall road against the law of evidence" className={mobileStyles.shadowImage}/>
                    <p id={imageStyles.sitin1} className={mobileStyles.mobileImageDesc}>Sit in at the Hall road against the law of evidence</p>
                  </div>
                  <div className={mobileStyles.mobile_layout_50}>
                    <img onClick={()=> props.setDisplayedOverlay(["1",1])} id={imageStyles.sitin2} src={sitin2} alt="Sit in at the Hall road against the law of evidence" className={mobileStyles.shadowImage}/>
                    <p id={imageStyles.sitin2} className={mobileStyles.mobileImageDesc}>A group of women protesters at the Hall road on 12 February 1983. Banners mention ‘Pakistan Women Lawyers Association’, who had joined efforts with WAF for the protest.</p>
                  </div>
                </div>
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.padded_bottom)}>
                  <p className={mobileStyles.mobilePara}>Walking in groups of four, the protesting women had defied Section 144 which banned public assemblies. Some women had even kept this hidden from male family members.</p>
                </div>

                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.padded_bottom)}>
                  <MobileQuote quote="Section 144 had been imposed so Hina Jilani had an idea that we should reach the high court in small groups of twos and threes and protest there,” she recalls. “But when we reached Hall Road, we could see that there was already a lot of police who had cordoned off the road so we couldn’t go ahead." source="Farida Shaheed, a founding WAF member" sourceImage={farida}></MobileQuote>
                </div>
                <MobileSectionTitle
                  image={Slide9_Habib}
                  title="Habib Jalib - in solidarity with WAF’s struggle"
                  chapterNumber="CHAPTER 3: RESISTANCE AGAINST THE LAW OF EVIDENCE"
                  note="Pictures in the chapter can be clicked for expanded view"
                />
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.increased_padded_top, mobileStyles.increased_padded_bottom)}>
                  <p className={mobileStyles.mobilePara}>The famous revolutionary poet also joined and addressed the women’s sit in. These photographs, which in later years would become popular images of Jalib, were taken at the sit in.</p>
                </div>
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.flexed_container, mobileStyles.padded_bottom)}>
                  <div className={mobileStyles.mobile_layout_50}>
                    <img onClick={()=> props.setDisplayedOverlay(["2",0])} id={imageStyles.jalib_1} src={jalib} alt="Habib Jalib amidst women protesters on 12 February 1983" className={mobileStyles.shadowImage}/>
                    <p id={imageStyles.jalib_1} className={mobileStyles.mobileImageDesc}>Habib Jalib amidst women protesters on 12 February 1983</p>
                  </div>
                  <div className={mobileStyles.mobile_layout_50}>
                    <img onClick={()=> props.setDisplayedOverlay(["2",1])} id={imageStyles.jalib_2} src={jalib2} alt="Habib Jalib’s passionate address to women protestors at the Hall road" className={mobileStyles.shadowImage}/>
                    <p id={imageStyles.jalib_2} className={mobileStyles.mobileImageDesc}>Habib Jalib’s passionate address to women protestors at the Hall road</p>
                  </div>
                </div>


                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.padded_top, mobileStyles.padded_bottom)}>
                  <p className={mobileStyles.mobilePara}>Jalib recited the following poem at the sit-in. The poem later became to be known as the WAF anthem</p>
                </div>
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.flexed_container, mobileStyles.padded_bottom)}>
                  <div style={{position: 'relative', alignItems: 'center'}} className={classNames(mobileStyles.mobile_layout_50, mobileStyles.centered_layout_row)}>
                    <img src={jalib_assault} alt="A Pakistan post stamp showing Habib Jalib" id={imageStyles.jalib_assault}/>
                    <img src={jalib_stamp} alt="A Pakistan post stamp showing Habib Jalib" className={classNames(imageStyles.rotate_0_dec_50_neg)} id={imageStyles.jalib_stamp}/>
                  </div>
                  <div className={mobileStyles.mobile_layout_50}>
                    <div className="urdu shair">
                      <p>اب دہر میں بے یار و مددگار نہیں ہم</p>
                      <p>پہلے کی طرح بےکس و لاچار نہیں ہم</p>
                      <div className="margined">
                        <p>آتا ہے ہمیں اپنے مقدر کو بنانا</p>
                        <p>تقدیر پہ شاکر پس دیوار نہیں ہم</p>
                      </div>
                      <div className="margined">
                        <p className="shair_source">حبیب جالب</p>
                      </div>
                    </div>
                  </div>
                </div>

                <MobileSectionTitle
                  image={Slide9_SitIn}
                  title="Laathi Charge and Tear gas shelling"
                  inverted
                  chapterNumber="CHAPTER 3: RESISTANCE AGAINST THE LAW OF EVIDENCE"
                  note="Pictures in the chapter can be clicked for expanded view"
                />
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.increased_padded_top, mobileStyles.padded_bottom)}>
                  <p className={mobileStyles.mobilePara}>The police proceeds to lathi-charge and fires tear-gas shells at the protesters on the Hall Road, Regal chowk and Mall Road. The photographs taken by journalists, Azhar Jaffery and Rahat Ali Dar, reveal the violence that ensued on the streets of Lahore.</p>
                </div>

                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100)}>
                  <div className={mobileStyles.galleryChevrons_container}>
                    <div>
                      <p className={slideStyles.galleryTitle}>Gallery</p>
                    </div>
                    <div style={{display: 'flex', alignItems: 'center'}}>
                      <div onClick={props.moveBackward(1)} className={slideStyles.prevSlideChev}><MdChevronLeft/></div>
                      <div onClick={props.moveForward(1)} className={slideStyles.nextSlideChev}><MdChevronRight/></div>
                    </div>
                  </div>
                </div>
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.padded_bottom)}>
                  <HorizontalScroll
                    scrollContainerRef={props.addScrollRef(1)}
                    xPos={props.xPos[1]}>
                      <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_50)}>
                          <img alt="Crackdown against the law of evidence" onClick={()=> props.setDisplayedOverlay(["3",0])} src={crackGallery1} className={classNames(mobileStyles.shadowImage, imageStyles.laathi_gallery)}/>
                      </div>
                      <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_50)}>
                          <img alt="Crackdown against the law of evidence" onClick={()=> props.setDisplayedOverlay(["3",1])} src={crackGallery2} className={classNames(mobileStyles.shadowImage, imageStyles.laathi_gallery)} />
                      </div>
                      <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_50)}>
                          <img alt="Crackdown against the law of evidence" onClick={()=> props.setDisplayedOverlay(["3",2])} src={crackGallery3} className={classNames(mobileStyles.shadowImage, imageStyles.laathi_gallery)}/>
                      </div>
                      <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_50)}>
                          <img alt="Crackdown against the law of evidence" onClick={()=> props.setDisplayedOverlay(["3",3])} src={crackGallery4} className={classNames(mobileStyles.shadowImage, imageStyles.laathi_gallery)}/>
                      </div>
                      <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_50)}>
                          <img alt="Crackdown against the law of evidence" src={crackGallery5} className={classNames(mobileStyles.shadowImage, imageStyles.laathi_gallery)} onClick={()=> props.setDisplayedOverlay(["3",4])}/>
                      </div>
                      <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_33, slideStyles.galleryItem_33_portrait)}>
                          <img alt="Crackdown against the law of evidence" src={crackGallery6} className={classNames(mobileStyles.shadowImage, imageStyles.laathi_gallery)} onClick={()=> props.setDisplayedOverlay(["3",5])}/>
                      </div>
                      <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_33, slideStyles.galleryItem_25_portrait)}>
                          <img alt="Crackdown against the law of evidence" src={crackGallery7} className={classNames(mobileStyles.shadowImage, imageStyles.laathi_gallery)} onClick={()=> props.setDisplayedOverlay(["3",6])}/>
                      </div>
                      <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_33, slideStyles.galleryItem_25_portrait)}>
                          <img alt="Crackdown against the law of evidence" src={crackGallery8} className={classNames(mobileStyles.shadowImage, imageStyles.laathi_gallery)} onClick={()=> props.setDisplayedOverlay(["3",7])}/>
                      </div>
                      <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_50)}>
                          <img alt="Crackdown against the law of evidence" src={crackGallery9} className={classNames(mobileStyles.shadowImage, imageStyles.laathi_gallery)} onClick={()=> props.setDisplayedOverlay(["3",8])}/>
                      </div>
                      <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_50)}>
                          <img alt="Crackdown against the law of evidence" src={crackGallery10} className={classNames(mobileStyles.shadowImage, imageStyles.laathi_gallery)} onClick={()=> props.setDisplayedOverlay(["3",9])}/>
                      </div>
                      <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_50)}>
                          <img alt="Crackdown against the law of evidence" src={crackGallery12} className={classNames(mobileStyles.shadowImage, imageStyles.laathi_gallery)} onClick={()=> props.setDisplayedOverlay(["3",10])}/>
                      </div>
                      <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_50)}>
                          <img alt="Crackdown against the law of evidence" src={crackGallery13} className={classNames(mobileStyles.shadowImage, imageStyles.laathi_gallery)} onClick={()=> props.setDisplayedOverlay(["3",11])}/>
                      </div>
                      <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_50)}>
                          <img alt="Crackdown against the law of evidence" src={crackGallery14} className={classNames(mobileStyles.shadowImage, imageStyles.laathi_gallery)} onClick={()=> props.setDisplayedOverlay(["3",12])}/>
                      </div>
                      <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_50)}>
                          <img alt="Crackdown against the law of evidence" src={crackGallery15} className={classNames(mobileStyles.shadowImage, imageStyles.laathi_gallery)} onClick={()=> props.setDisplayedOverlay(["3",13])}/>
                      </div>
                      <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_50)}>
                          <img alt="Crackdown against the law of evidence" src={crackGallery16} className={classNames(mobileStyles.shadowImage, imageStyles.laathi_gallery)} onClick={()=> props.setDisplayedOverlay(["3",14])}/>
                      </div>
                      <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_50)}>
                          <img alt="Crackdown against the law of evidence" src={crackGallery17} className={classNames(mobileStyles.shadowImage, imageStyles.laathi_gallery)} onClick={()=> props.setDisplayedOverlay(["3",15])}/>
                      </div>
                  </HorizontalScroll>
                </div>

                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.padded_bottom)}>
                  <p className={mobileStyles.mobilePara}>Samina Rahman, a founding WAF member from Lahore, recalls how women felt hopeful and liberated during the protest at Hall road/ Regal chowk</p>
                </div>
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.padded_bottom)}>
                  <MobileQuote quote="It was unusual. We were breaking silence and challenging the martial law. A lot of it was based on impulse; just the desire to break barriers. It was a very liberating time. When you’re on the street, resisting force and you feel you’re breaking through, there is a moment of hope." source="Samina Rehman" sourceImage={samina}></MobileQuote>
                </div>

                <MobileSectionTitle
                  image={Chapter3Next}
                  title="Newspaper Coverage"
                  chapterNumber="CHAPTER 3: RESISTANCE AGAINST THE LAW OF EVIDENCE"
                  note="Pictures in the chapter can be clicked for expanded view"
                />

                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.padded_top, mobileStyles.padded_bottom)}>
                  <div className={mobileStyles.galleryChevrons_container}>
                    <div>
                      <p className={slideStyles.galleryTitle}>Gallery</p>
                    </div>
                    <div style={{display: 'flex', alignItems: 'center'}}>
                      <div onClick={props.moveBackward(2)} className={slideStyles.prevSlideChev}><MdChevronLeft/></div>
                      <div onClick={props.moveForward(2)} className={slideStyles.nextSlideChev}><MdChevronRight/></div>
                    </div>
                  </div>
                </div>
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.increased_padded_bottom)}>
                  <HorizontalScroll
                    scrollContainerRef={props.addScrollRef(2)}
                    xPos={props.xPos[2]}>
                      <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_33)}>
                          <img alt="Crackdown against the law of evidence" onClick={()=> props.setDisplayedOverlay(["4",0])} src={afterMath1} className={classNames(mobileStyles.shadowImage, imageStyles.laathi_gallery)}/>
                      </div>
                      <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_40)}>
                          <img alt="Crackdown against the law of evidence" onClick={()=> props.setDisplayedOverlay(["4",1])} src={afterMath2} className={classNames(mobileStyles.shadowImage, imageStyles.laathi_gallery)} />
                      </div>
                      <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_33)}>
                          <img alt="Crackdown against the law of evidence" onClick={()=> props.setDisplayedOverlay(["4",2])} src={afterMath3} className={classNames(mobileStyles.shadowImage, imageStyles.laathi_gallery)}/>
                      </div>
                      <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_50)}>
                          <img alt="Crackdown against the law of evidence" onClick={()=> props.setDisplayedOverlay(["4",3])} src={afterMath4} className={classNames(mobileStyles.shadowImage, imageStyles.laathi_gallery)}/>
                      </div>
                      <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_50)}>
                          <img alt="Crackdown against the law of evidence" src={afterMath5} className={classNames(mobileStyles.shadowImage, imageStyles.laathi_gallery)} onClick={()=> props.setDisplayedOverlay(["4",4])}/>
                      </div>
                  </HorizontalScroll>
                </div>

                <NextChapterTitle
                  image={Chapter3Next}
                  title="WAF's Activism"
                  nextChapter="chapter4"
                  prevChapter="chapter2"
                />

                <Overlay
                  oId="1"
                  displayedOverlay={props.displayedOverlay}
                  closeOverlay={props.closeOverlay}
                  setDisplayedOverlay={props.setDisplayedOverlay}
                  slides={
                    [{
                      description : "Sit in at the Hall road against the law of evidence",
                      title : "Sample Title",
                      source : "Photograph by LalaRukh",
                      render : ()=> <img id={overlayStyles.sitin1} alt="Sit in at the Hall road against the law of evidence" src={sitin1}></img>,
                    },
                    {
                      description : `A group of women protesters at the Hall road on 12 February 1983. Banners mention ‘Pakistan Women Lawyers Association’, who had joined efforts with WAF for the protest.`,
                      title : "Sample Title2",
                      source : "Photograph by Rahat Ali Dar",
                      render : ()=> <img id={overlayStyles.sitin2} alt="Sit in at the Hall road against the law of evidence" src={sitin2}></img>,
                    }]
                  }
                />
                <Overlay
                  oId="2"
                  displayedOverlay={props.displayedOverlay}
                  closeOverlay={props.closeOverlay}
                  setDisplayedOverlay={props.setDisplayedOverlay}
                  slides={
                    [{
                      description : "Habib Jalib amidst women protesters on 12 February 1983",
                      title : "Sample Title",
                      source : "",
                      render : ()=> <img id={overlayStyles.jalib1} alt="Habib Jalib amidst women protesters on 12 February 1983" src={jalib}></img>,
                    },
                    {
                      description : "Habib Jalib’s passionate address to women protestors at the Hall road",
                      title : "Sample Title2",
                      source : "Photograph by Alison Venning",
                      render : ()=> <img id={overlayStyles.jalib2} alt="Habib Jalib’s passionate address to women protestors at the Hall road" src={jalib2}></img>,
                    }]
                  }
                />

                <Overlay
                  oId="3"
                  displayedOverlay={props.displayedOverlay}
                  closeOverlay={props.closeOverlay}
                  setDisplayedOverlay={props.setDisplayedOverlay}
                  slides={
                    [{
                      description : "Lathi charge and tear gas shelling at Regal chowk",
                      title : "Sample Title",
                      source : "The Second Floor's (T2F) Facebook page",
                      render : ()=> <img id={overlayStyles.crackdown1} alt="Crackdown against the law of evidence" src={crackGallery1}></img>,
                    },
                    {
                      description : "Lathi charge by policemen and policewomen to disperse the protests",
                      title : "Sample Title2",
                      source : "Photograph by Azhar Jaffery",
                      render : ()=> <img id={overlayStyles.crackdown2} alt="Crackdown against the law of evidence" src={crackGallery2}></img>,
                    },
                    {
                      description : "A protestor faces a policewoman during the lathi charge",
                      title : "Sample Title2",
                      source : "Photograph by Azhar Jaffery",
                      render : ()=> <img id={overlayStyles.crackdown3} alt="Crackdown against the law of evidence" src={crackGallery3}></img>,
                    },
                    {
                      description : "A collapsed protester holds on to a policeman’s baton",
                      title : "Sample Title2",
                      source : "Photograph by Azhar Jaffery",
                      render : ()=> <img id={overlayStyles.crackdown4} alt="Crackdown against the law of evidence" src={crackGallery4}></img>,
                    },
                    {
                      description : "A protester clashes with a policewoman",
                      title : "Sample Title2",
                      source : "Photograph by Azhar Jaffery",
                      render : ()=> <img id={overlayStyles.crackdown5} alt="Crackdown against the law of evidence" src={crackGallery5}></img>,
                    },
                    {
                      description : "A protester ducks to escape batons of the police",
                      title : "Sample Title2",
                      source : "Photograph by Azhar Jaffery",
                      render : ()=> <img id={overlayStyles.crackdown6} alt="Crackdown against the law of evidence" src={crackGallery6}></img>,
                    },
                    {
                      description : "A woman attends to an injured protester",
                      title : "Sample Title2",
                      source : "Photograph by Azhar Jaffery",
                      render : ()=> <img id={overlayStyles.crackdown7} alt="Crackdown against the law of evidence" src={crackGallery7}></img>,
                    },
                    {
                      description : "Mass arrests also took place following the lathi charge, however, reports convey the prisoners were let go after a few hours.",
                      title : "Sample Title2",
                      source : "Photograph by Azhar Jaffery",
                      render : ()=> <img id={overlayStyles.crackdown8} alt="Crackdown against the law of evidence" src={crackGallery8}></img>,
                    },
                    {
                      description : "A group of women supporting an injured protester ",
                      title : "Sample Title2",
                      source : "Photograph by Alison Venning",
                      render : ()=> <img id={overlayStyles.crackdown9} alt="Crackdown against the law of evidence" src={crackGallery9}></img>,
                    },
                    {
                      description : "A famous image of Asma Jahangir, a member of the Pakistan Women Lawyers’ Association, facing the attacks of the police.",
                      title : "Sample Title2",
                      source : "",
                      render : ()=> <img id={overlayStyles.crackdown10} alt="Crackdown against the law of evidence" src={crackGallery10}></img>,
                    },
                    {
                      description : "Aitzaz Ahsan, the famous lawyer is pictured trying to quell the blows of police on the protesters",
                      title : "Sample Title2",
                      source : "Photograph by Azhar Jaffery",
                      render : ()=> <img id={overlayStyles.crackdown11} alt="Crackdown against the law of evidence" src={crackGallery12}></img>,
                    },
                    {
                      description : "A protester surrounded by policewomen.",
                      title : "Photograph by Azhar Jaffery",
                      source : "asas2",
                      render : ()=> <img id={overlayStyles.crackdown12} alt="Crackdown against the law of evidence" src={crackGallery13}></img>,
                    },
                    {
                      description : "Habib Jalib, the famous poet amidst attacking batons",
                      title : "DAWN",
                      source : "asas2",
                      render : ()=> <img id={overlayStyles.crackdown13} alt="Crackdown against the law of evidence" src={crackGallery14}></img>,
                    },
                    {
                      description : "A group of women protesters clash with policemen",
                      title : "Photograph by Rahat Ali Dar",
                      source : "asas2",
                      render : ()=> <img id={overlayStyles.crackdown14} alt="Crackdown against the law of evidence" src={crackGallery15}></img>,
                    },
                    {
                      description : "A group of women protesters clash with policemen",
                      title : "Sample Title2",
                      source : "Photograph by Rahat Ali Dar",
                      render : ()=> <img id={overlayStyles.crackdown15} alt="Crackdown against the law of evidence" src={crackGallery16}></img>,
                    },
                    {
                      description : "A group of women protesters clash with policemen",
                      title : "Sample Title2",
                      source : "Photograph by Rahat Ali Dar",
                      render : ()=> <img id={overlayStyles.crackdown16} alt="Crackdown against the law of evidence" src={crackGallery17}></img>,
                    }]
                  }
                />

                <Overlay
                  oId="4"
                  displayedOverlay={props.displayedOverlay}
                  closeOverlay={props.closeOverlay}
                  setDisplayedOverlay={props.setDisplayedOverlay}
                  slides={
                    [{
                      description : <span>Daily <i>Jang</i> covers WAF's protest against the 'Law of evidence' - 13 Feb 1983</span>,
                      title : "",
                      source : "",
                      render : ()=> <img alt="Daily Jang - 13 Feb 1983" src={afterMath1} id={overlayStyles.afterMath1}></img>,
                    },
                    {
                      description: <span>Daily <i>Jang</i> - 13 Feb 1983</span>,
                      title : "Sample Title2",
                      source : "",
                      render : ()=> <img alt="Daily Jang - 13 Feb 1983" src={afterMath2} id={overlayStyles.afterMath2}></img>,
                    },
                    {
                      description : <span>An editorial in Daily <i>Jang</i> about the protests - 14 Feb 1983</span>,
                      title : "Sample Title2",
                      source : "",
                      render : ()=> <img alt="Daily Jang - 14 Feb 1983" src={afterMath3} id={overlayStyles.afterMath3}></img>,
                    },
                    {
                      description : <span>Daily <i>Jang</i> - 14 Feb 1983</span>,
                      title : "Sample Title2",
                      source : "",
                      render : ()=> <img alt="Daily Jang - 14 Feb 1983" src={afterMath4} id={overlayStyles.afterMath4}></img>,
                    },
                    {
                      description : <span>Reaction of Jamat-i-Islami leaders to the protests, published in Daily <i>Jang</i> - 14 Feb 1983</span>,
                      title : "Sample Title2",
                      source : "",
                      render : ()=> <img alt="Daily Jang - 14 Feb 1983" src={afterMath5} id={overlayStyles.afterMath5}></img>,
                    }]
                  }
                />
              </div>
            )
          }
        }
      </MobileSlide>
    ),
    menuInverted : true,
  },
  "chapter4" : {
    name: "Chapter 4: WAF's Activism",
    component : (
      <MobileSlide>
        {
          (props)=>{
            return (
              <div>
                <ChapterTitleMobile
                  inverted
                  image={Chapter4Title}
                  chapter_number="4"
                  chapter_title="WAF's Activism"
                  images={[
                    {image: Post83Title1, id: chTStyles.Post83Title1, shift: 12},
                    {image: Post83Title2, id: chTStyles.Post83Title2, shift: -18},
                    {image: WAF_logo, id: chTStyles.WafLogo, shift: 17}
                  ]}
                  gradient='linear-gradient(to bottom, rgba(30,87,153,0) 0%,rgba(53,68,75,0.48) 48%,rgba(53,68,75,0.97) 97%,rgba(53,68,75,1) 100%)'
                />
                <MobileSectionTitle
                  image={Chapter3Next}
                  title="WAF’s activism post 1983"
                  chapterNumber="CHAPTER 4: WAF'S ACTIVISM"
                  note="Pictures in the chapter can be clicked for expanded view"
                />
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.increased_padded_top, mobileStyles.padded_bottom)}>
                  <p className={mobileStyles.mobilePara}>The Women’s Action Forum continued their struggle for upholding women’s rights. Here, we present a few photos of WAF’s activism post 1983.</p>
                </div>
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.padded_bottom)}>
                  <div className={mobileStyles.galleryChevrons_container}>
                    <div>
                      <p className={slideStyles.galleryTitle}>Gallery</p>
                    </div>
                    <div style={{display: 'flex', alignItems: 'center'}}>
                      <div onClick={props.moveBackward(1)} className={slideStyles.prevSlideChev}><MdChevronLeft/></div>
                      <div onClick={props.moveForward(1)} className={slideStyles.nextSlideChev}><MdChevronRight/></div>
                    </div>
                  </div>
                </div>
                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.padded_bottom)}>
                  <HorizontalScroll
                    scrollContainerRef={props.addScrollRef(1)}
                    xPos={props.xPos[1]}>
                    <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_50)}>
                        <img onClick={()=> props.setDisplayedOverlay(["1",0])} alt="A procession of WAF activists at the 10th anniversary march of the February 1983 sit-in" src={post83Gallery1} className={classNames(mobileStyles.shadowImage, imageStyles.laathi_gallery)}/>
                    </div>
                    <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_50)}>
                        <img onClick={()=> props.setDisplayedOverlay(["1",1])} alt="" src={post83Gallery2} className={classNames(mobileStyles.shadowImage, imageStyles.laathi_gallery)}/>
                    </div>
                    <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_50)}>
                        <img onClick={()=> props.setDisplayedOverlay(["1",2])} alt="" src={Post83Title2} className={classNames(mobileStyles.shadowImage, imageStyles.laathi_gallery)}/>
                    </div>
                    <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_50)}>
                        <img onClick={()=> props.setDisplayedOverlay(["1",3])} alt="In 1986, when two young women were raped and murdered in Karachi, WAF Lahore members protested by burning dupattas at the press club." src={post83Gallery4} className={classNames(mobileStyles.shadowImage, imageStyles.laathi_gallery)}/>
                    </div>
                    <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_50)}>
                        <img onClick={()=> props.setDisplayedOverlay(["1",4])} alt="WAF members protest against the 15th constitutional amendment (so called Shariat Bill) during Nawaz Sharif’s government (1998)" src={post83Gallery5} className={classNames(mobileStyles.shadowImage, imageStyles.laathi_gallery)}/>
                    </div>
                    <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_50)}>
                        <img onClick={()=> props.setDisplayedOverlay(["1",5])} alt="" src={post83Gallery6} className={classNames(mobileStyles.shadowImage, imageStyles.laathi_gallery)}/>
                    </div>
                  </HorizontalScroll>
                </div>

                <MobileSectionTitle
                  image={SlideLala}
                  inverted
                  title="Art of Resistance: Lala Rukh"
                  chapterNumber="CHAPTER 4: WAF'S ACTIVISM"
                  note="Pictures in the chapter can be clicked for expanded view"
                />

                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.increased_padded_top, mobileStyles.padded_bottom)}>
                  <p className={mobileStyles.mobilePara}>In the bottom row of the iconic group photo from the 1982 WAF National Convention Lahore lies Lala Rukh, an artist who also taught at Lahore’s National College of Arts. As part of her activism for WAF, she designed many posters and screen prints which reflect the ethos of the Women’s Action Forum. After Lala’s death in 2017, her work would also be added to the collection at the famous Metropolitan Museum of the Art in New York.</p>
                </div>

                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_67, mobileStyles.padded_bottom)}>
                  <HotspotImage pulsating marginBottom="0px" width="75%" imageBorderClass={slideStyles.imgBorder} bordered rotate imageRotateClass={imageStyles.rotate_0_dec_75}  imageSrc={lalaArchives} vbx='800' vby='655' r='15' hotspots={[{x: '425', y: '430', fill: 'white', opacity: '0.5', name: 'Lala Rukh', text: `Lala Rukh (1948–2017) was an eminent artist who also taught at Lahore's National College of Arts.  Lala Rukh’s work has also been added to the collection of the famous Metropolitan Museum of the art. As part of her activism with WAF, she designed many posters for it’s events over the years.`}]} ></HotspotImage>
                </div>

                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.padded_bottom)}>
                  <div className={mobileStyles.galleryChevrons_container}>
                    <div>
                      <p className={slideStyles.galleryTitle}>Gallery</p>
                    </div>
                    <div style={{display: 'flex', alignItems: 'center'}}>
                      <div onClick={props.moveBackward(2)} className={slideStyles.prevSlideChev}><MdChevronLeft/></div>
                      <div onClick={props.moveForward(2)} className={slideStyles.nextSlideChev}><MdChevronRight/></div>
                    </div>
                  </div>
                </div>

                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.increased_padded_bottom)}>
                  <HorizontalScroll
                    scrollContainerRef={props.addScrollRef(2)}
                    xPos={props.xPos[2]}>
                    <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_40)}>
                        <img onClick={()=> props.setDisplayedOverlay(["2",0])} alt="" src={lalaGallery1} className={classNames(mobileStyles.shadowImage, imageStyles.lala_gallery)}/>
                    </div>
                    <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_40)}>
                        <img onClick={()=> props.setDisplayedOverlay(["2",1])} alt="" src={lalaGallery2} className={classNames(mobileStyles.shadowImage, imageStyles.lala_gallery)}/>
                    </div>
                    <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_40)}>
                        <img onClick={()=> props.setDisplayedOverlay(["2",2])} alt="" src={lalaGallery3} className={classNames(mobileStyles.shadowImage, imageStyles.lala_gallery)}/>
                    </div>
                    <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_40)}>
                        <img onClick={()=> props.setDisplayedOverlay(["2",3])} alt="" src={lalaGallery4} className={classNames(mobileStyles.shadowImage, imageStyles.lala_gallery)}/>
                    </div>
                    <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_40)}>
                        <img onClick={()=> props.setDisplayedOverlay(["2",4])} alt="" src={lalaGallery5} className={classNames(mobileStyles.shadowImage, imageStyles.lala_gallery)}/>
                    </div>
                    <div className={classNames(slideStyles.galleryItem_container, mobileStyles.galleryItem_40)}>
                        <img onClick={()=> props.setDisplayedOverlay(["2",5])} alt="" src={lalaGallery6} className={classNames(mobileStyles.shadowImage, imageStyles.lala_gallery)}/>
                    </div>
                  </HorizontalScroll>
                </div>

                <MobileSectionTitle
                  image={Slide12Back}
                  title="Women of WAF"
                  chapterNumber="CHAPTER 4: WAF'S ACTIVISM"
                  note="Pictures in the chapter can be clicked for expanded view"
                />

                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.increased_padded_top, mobileStyles.padded_bottom)}>
                  <p className={mobileStyles.mobilePara}>Many of WAF’s members continued to fight for women’s rights throughout their lives. In the next slide, you can browse their profiles by interacting with an iconic photo from the first WAF convention in Lahore (1982)</p>
                </div>


                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_67, mobileStyles.padded_bottom)}>
                  <HotspotImage width="100%" marginBottom="50px" imageSrc={lalaArchives} vbx='800' vby='655' r='11'
                    hotspots={[{x: '425', y: '430', fill: '#bdbdbd', stroke: '#606060', opacity: '0.8', name: 'Lala Rukh', text: `Lala Rukh (1948–2017) was an eminent artist who also taught at Lahore's National College of Arts.  Lala Rukh’s work has also been added to the collection of the famous Metropolitan Museum of the Art. As part of her activism with WAF, she designed many posters for it’s events over the years.`},
                    {x: '200', y: '170', fill: '#bdbdbd', stroke: '#606060', opacity: '0.8', name: 'Najma Sadeque', text: `One of the founding members of the Women’s Action Forum, Najma Sadeque (1943 - 2015) was a leading woman journalist, author, human rights activist, an artist, an environmentalist and a painter. She also founded the Shirkat Gah in 1975, a women's NGO that worked towards advocating and promoting women’s rights and empowerment. `},
                    {x: '340', y: '250', fill: '#bdbdbd', stroke: '#606060', opacity: '0.8', name: 'Farida Shaheed', text: `Farida Shaheed is a Pakistani sociologist and feminist human rights activist. In 2012, she was appointed the United Nations Special Rapporteur in the field of cultural rights. She is also a senior member at Shirkat Gah, the organization that lay the foundation for WAF.`},
                    {x: '440', y: '250', fill: '#bdbdbd', stroke: '#606060', opacity: '0.8', name: 'Ghazala Rehman', text: `Ghazala Rahman Rafiq is an educationist, and social reformer from Karachi who also founded the Sindh Abhyas Academy at SZABIST.`},
                    {x: '540', y: '250', fill: '#bdbdbd', stroke: '#606060', opacity: '0.8', name: 'Fareeha Zafar', text: <p>One of SAHE’s (Society for the Advancement of Education) founding members and its director for 10 years. She is also the editor of the book, <i>Finding Our Way: Women in Pakistan</i>.</p>},
                    {x: '650', y: '250', fill: '#bdbdbd', stroke: '#606060', opacity: '0.8', name: 'Nighat Said Khan', text: `A Pakistani feminist activist, researcher and author, Nighat Said Khan is the director and founder of the Applied Socio-Economic Research (ASR) Resource Centre and a founding member of the Women's Action Forum.`},
                    {x: '710', y: '300', fill: '#bdbdbd', stroke: '#606060', opacity: '0.8', name: 'Aban Markar-Kabraji', text: 'Aban Markar-Kabraji is a biologist and scientist of Parsi origin. In addition to her activism with WAF, she has also been recognized for her services towards environmental conservation, both nationally and internationally. She is the current Regional Director of the Asia Regional Office at the IUCN, the International Union for Conservation of Nature. Aban Markar-Kabraji was also awarded the Tamgha-e-Imtiaz in 2018 for her services to the state of environmental awareness in Pakistan.'},
                    {x: '125', y: '300', fill: '#bdbdbd', stroke: '#606060', opacity: '0.8', name: 'Samina Rahman', text: `A founding member of Women’s Action Forum (WAF) Lahore, Samina Rahman has been a teacher, educationist and human rights activist for over four decades. She taught at the Quaid-e-Azam University and University of the Punjab, before establishing Lahore Grammar School in 1979 with a group of like-minded women, where she still works.`},
                    {x: '240', y: '340', fill: '#bdbdbd', stroke: '#606060', opacity: '0.8', name: 'Khawar Mumtaz', text: `A women's rights activist, university lecturer and author, Khawar Mumtaz continued her activism and served as Chairwoman of the National Commission on the Status of Women, a federal government agency established to examine and uphold laws and policies to safeguard women’s rights.`},
                    {x: '500', y: '360', fill: '#bdbdbd', stroke: '#606060', opacity: '0.8', name: 'Hilda Saeed', text: `A microbiologist-turned-women’s-rights activist, Hilda Saeed is the current chairperson of Shirkat Gah, the organization that lay the foundation for WAF. She went on to fight for improved maternal and reproductive health for women.`},
                    {x: '620', y: '360', fill: '#bdbdbd', stroke: '#606060', opacity: '0.8', name: 'Nigar Ahmad', text: `Nigar Ahmad (1945 - 2017), an eminent member of WAF Lahore would go on to found Aurat foundation, a leading women’s rights NGO in Pakistan in her later years.`}]}
                  ></HotspotImage>
                </div>

                <MobileSectionTitle
                  image={AuratMarchBack}
                  title="Aurat March"
                  chapterNumber="CHAPTER 4: WAF'S ACTIVISM"
                  note="Pictures in the chapter can be clicked for expanded view"
                />

                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.increased_padded_top, mobileStyles.increased_padded_bottom)}>
                  <p className={mobileStyles.mobilePara}>The WAF continues to march on. A new generation of Pakistani feminists and rights activists have joined the field. Like WAF activists - who led a political movement against the most brutal military dictator in Pakistan’s history - the young activists have similarly taken up political fight at a time when civil liberties are being curtailed, media’s freedom muzzled and a threat is posed to the democratic structure of Pakistan. The Aurat March - in a span of less than three years - has assumed an iconic status. It reverberates with the spirit of WAF’s activism on the streets of Lahore.</p>
                </div>

                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.padded_bottom)}>
                  <div className={mobileStyles.galleryChevrons_container}>
                    <div>
                      <p className={slideStyles.galleryTitle}>Gallery</p>
                    </div>
                    <div style={{display: 'flex', alignItems: 'center'}}>
                      <div onClick={props.moveBackward(3)} className={slideStyles.prevSlideChev}><MdChevronLeft/></div>
                      <div onClick={props.moveForward(3)} className={slideStyles.nextSlideChev}><MdChevronRight/></div>
                    </div>
                  </div>
                </div>

                <div className={classNames(mobileStyles.mobile_layout, mobileStyles.mobile_layout_100, mobileStyles.padded_bottom)}>
                  <HorizontalScroll
                    scrollContainerRef={props.addScrollRef(3)}
                    xPos={props.xPos[3]}>
                    <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_50)}>
                        <img onClick={()=> props.setDisplayedOverlay(["3",0])} alt="" src={auratMarch1} className={classNames(mobileStyles.shadowImage, imageStyles.laathi_gallery)}/>
                    </div>
                    <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_50)}>
                        <img onClick={()=> props.setDisplayedOverlay(["3",1])} alt="" src={auratMarch2} className={classNames(mobileStyles.shadowImage, imageStyles.laathi_gallery)}/>
                    </div>
                    <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_50)}>
                      <VideoLink setDisplayedOverlay={props.setDisplayedOverlay} overlayArray={["3",2]} image={auratMarchVideo} imageStyle={{width: '100%', alignSelf: 'center', marginBottom: '5px', cursor: 'pointer'}} linkMessage="Aurat March Lahore 2020 - Highlights video" linkSource="Source: Aurat March"/>
                    </div>
                    <div className={classNames(slideStyles.galleryItem_container, slideStyles.galleryItem_50)}>
                        <img onClick={()=> props.setDisplayedOverlay(["3",3])} alt="" src={auratMarch3} className={classNames(mobileStyles.shadowImage, imageStyles.laathi_gallery)}/>
                    </div>
                  </HorizontalScroll>
                </div>

                <NextChapterTitle
                  inverted
                  image={ProjectCreditsBack}
                  title="Credits"
                  nextChapter="credits"
                  prevChapter="chapter3"
                />

                <Overlay
                  oId="1"
                  displayedOverlay={props.displayedOverlay}
                  closeOverlay={props.closeOverlay}
                  setDisplayedOverlay={props.setDisplayedOverlay}
                  slides={
                    [{
                      description : "A procession of WAF activists at the 10th anniversary march of the February 1983 sit-in",
                      title : "WAF protests against banning of women from sports and co-education institutions",
                      source : "The Second Floor's (T2F) Facebook page",
                      render : ()=> <img id={overlayStyles.post831} alt="A procession of WAF activists at the 10th anniversary march of the February 1983 sit-in" src={post83Gallery1}></img>,
                    },
                    {
                      description : "A demonstration by WAF in Lahore",
                      title : "Sample Title2",
                      source : "The Second Floor's (T2F) Facebook page",
                      render : ()=> <img id={overlayStyles.post832} alt="" src={post83Gallery2}></img>,
                    },
                    {
                      description : "A demonstration by WAF in Lahore",
                      title : "Sample Title2",
                      source : "The Second Floor's (T2F) Facebook page",
                      render : ()=> <img id={overlayStyles.post833} alt="" src={Post83Title2}></img>,
                    },
                    {
                      description : "In 1986, when two young women were raped and murdered in Karachi, WAF Lahore members protested by burning dupattas at the press club.",
                      title : "WAF protests against banning of women from sports and co-education institutions",
                      source : "Twitter: Aurat March Khi",
                      originalLink: 'https://twitter.com/AuratMarchKHI/status/1234736347342147584',
                      render : ()=> <img id={overlayStyles.post834} alt="In 1986, when two young women were raped and murdered in Karachi, WAF Lahore members protested by burning dupattas at the press club." src={post83Gallery4}></img>,
                    },{
                      description : "WAF members protest against the 15th constitutional amendment (so called Shariat Bill) during Nawaz Sharif’s government (1998)",
                      title : "Sample Title2",
                      source : "The Second Floor's (T2F) Facebook page",
                      render : ()=> <img id={overlayStyles.post835} alt="WAF members protest against the 15th constitutional amendment (so called Shariat Bill) during Nawaz Sharif’s government (1998)" src={post83Gallery5}></img>,
                    },{
                      description : <p>A protest by WAF members. Verses from the WAF anthem (right) by Jalib and the feminist poem <i>chadar aur char diwari</i> (left) by Fahmida Riaz can be seen on the placards of activists</p>,
                      title : "Sample Title2",
                      source : "The Second Floor's (T2F) Facebook page",
                      render : ()=> <img id={overlayStyles.post836} alt="" src={post83Gallery6}></img>,
                    }]
                  }
                />

                <Overlay
                  oId="2"
                  displayedOverlay={props.displayedOverlay}
                  closeOverlay={props.closeOverlay}
                  setDisplayedOverlay={props.setDisplayedOverlay}
                  slides={
                    [{
                      description : "Demanding equal rights and striving for it by unshackling handcuffs symbolizing confining of women to their homes draped in a veil of morality imposed on their bodies.",
                      title : "Sample Title",
                      source : "documenta14.de",
                      render : ()=> <img id={overlayStyles.lalaGallery1} alt="" src={lalaGallery1}></img>,
                    },
                    {
                      description : "An invitation to the ten year anniversary celebration of the sit-in of February 1983. Images of women being lathi charged in 1983 can also be seen.",
                      title : "Sample Title2",
                      source : "documenta14.de",
                      render : ()=> <img id={overlayStyles.lalaGallery2} alt="" src={lalaGallery2}></img>,
                    },
                    {
                      description : "Poster titled, ‘Crime against women’ presents a collage of news clippings of incidents of violence and injustice against women.",
                      title : "Sample Title2",
                      source : "documenta14.de",
                      render : ()=> <img id={overlayStyles.lalaGallery3} alt="" src={lalaGallery3}></img>,
                    },
                    {
                      description : "A calendar from the year 1985 publicizing Women’s Action Forum.",
                      title : "Sample Title2",
                      source : "documenta14.de",
                      render : ()=> <img id={overlayStyles.lalaGallery4} alt="" src={lalaGallery4}></img>,
                    },{
                      description : "An image critiquing the nexus of patriarchy, capitalism and religiosity in subjugating the minds and bodies of women.",
                      title : "Sample Title2",
                      source : "documenta14.de",
                      render : ()=> <img id={overlayStyles.lalaGallery5} alt="" src={lalaGallery5}></img>,
                    },{
                      description : <p><p>A publicity poster designed by Lala Rukh for the first WAF Convention held in 1982 in Lahore. In the background, a statement repeats itself: </p><p>Translation: ‘It is a crime against humanity that our women are confined to the four walls of their houses like prisoners’</p><p>In the foreground, Fatima Jinnah is seen, alongside Muhammad Ali Jinnah, representing women leadership in the nation’s history</p></p>,
                      title : "Sample Title2",
                      source : "artasiapacific.com",
                      render : ()=> <img id={overlayStyles.lalaGallery6} alt="" src={lalaGallery6}></img>,
                    }]
                  }
                />

                <Overlay
                  oId="3"
                  displayedOverlay={props.displayedOverlay}
                  closeOverlay={props.closeOverlay}
                  setDisplayedOverlay={props.setDisplayedOverlay}
                  slides={
                    [{
                      description : <p><i>Aurat March</i> 2020</p>,
                      title : "",
                      source : "Aurat March",
                      render : ()=> <img id={overlayStyles.am1} alt="" src={auratMarch1}></img>,
                    },
                    {
                      description : <p>While the emphasis towards body politics during the Aurat March marks a shift, it still captures the essence of feminist movements of the past. Pictured here: Nighat Said Khan, a founding member of WAF, holding up a poster supporting the slogan "mera jism meri marzi", that became the unofficial rallying cry of the Aurat March.</p>,
                      title : "Sample Title2",
                      source : "Aurat March",
                      render : ()=> <img id={overlayStyles.am2} alt="" src={auratMarch2}></img>,
                    },
                    {
                      description : <p>Highlights video for <i>Aurat March</i> 2020</p>,
                      title : "Sample Title2",
                      source : "Aurat March Lahore | Youtube",
                      render : ()=> <VideoFrame link='https://www.youtube.com/embed/R-ekMXgX8YA'/>,
                    },
                    {
                      description : <p>Aurat March marked a shift in the mode of feminist politics--moving away from respectability politics of yesteryears to use of humour and confrontational slogans that captured the language of the current generation.</p>,
                      title : "WAF protests against banning of women from sports and co-education institutions",
                      source : "Aurat March",
                      render : ()=> <img id={overlayStyles.am3} alt="" src={auratMarch3}></img>,
                    }]
                  }
                />
              </div>
            )
          }
        }
      </MobileSlide>
    ),
    menuInverted : true,
  },
  "credits" : {
      name: "Credits",
      component : (
        <MobileSlide>
          {
            (props)=>{
              return (
                <div>
                  <ProjectCreditsMobile
                    image={ProjectCreditsBack}
                    disclaimer="These projects are based on information and resources collected by students of the course Walking the streets of Lahore taught at LUMS"
                    projectName="Political movements in Lahore "
                    studentNames="Usama Liaqat, Syeda Nida Hasan, Syeda Fatima Tehseen, Muhammad Abdullah Niazi, Zarish Shahzad, Amal Arif, Muhammad Asfandyar"
                    supervisor={{name: 'Dr Ali Usman Qasmi', desig: 'Associate Professor (History), Department of Humanities and Social Sciences, LUMS'}}
                    optionalLogo={WAF_logo}
                    description="Under the military rule of General Zia-ul-Haq (1977-1988), the women’s movement emerged in direct opposition to state repression. The Women Action Forum was a crucial part of the movement."
                  />
                </div>
              )
            }
          }
        </MobileSlide>
      ),
      menuInverted : true,
    }
}

export {
    slideMap,
    slideOrder,
    imageArr,
    chapterArr,
    mobileSlideMap,
    mobileImageArr
};
